//和风天气城市数据
let dataAllCitys={
  "countries":[
    [0,"中国 - China"], [1,"印度尼西亚 - Indonesia"]
  ],
  "0":[
    [0,"北京市"],[1,"天津市"],[2,"上海市"],[3,"重庆市"],[4,"河北省"],[5,"山西省"],[6,"内蒙古"],[7,"辽宁省"],[8,"吉林省"],[9,"黑龙江省"],[10,"江苏省"],[11,"浙江省"],[12,"安徽省"],[13,"福建省"],[14,"江西省"],[15,"山东省"],[16,"河南省"],[17,"湖北省"],[18,"湖南省"],[19,"广东省"],[20,"广西省"],[21,"海南省"],[22,"四川省"],[23,"贵州省"],[24,"云南省"],[25,"西藏"],[26,"陕西省"],[27,"甘肃省"],[28,"青海省"],[29,"宁夏省"],[30,"新疆"],[31,"香港"],[32,"澳门"],[33,"台湾省"]
  ],
  "0_0":[
    [0,"北京市","CN101010100"]
  ],
  "0_0_0":[
    [0,"海淀","CN101010200"],[1,"朝阳","CN101010300"],[2,"顺义","CN101010400"],[3,"怀柔","CN101010500"],[4,"通州","CN101010600"],[5,"昌平","CN101010700"],[6,"延庆","CN101010800"],[7,"丰台","CN101010900"],[8,"石景山","CN101011000"],[9,"大兴","CN101011100"],[10,"房山","CN101011200"],[11,"密云","CN101011300"],[12,"门头沟","CN101011400"],[13,"平谷","CN101011500"],[14,"东城","CN101011600"],[15,"西城","CN101011700"]
  ],
  "0_1":[
    [0,"天津市","CN101030100"]
  ],
  "0_1_0":[
    [0,"武清","CN101030200"],[1,"宝坻","CN101030300"],[2,"东丽","CN101030400"],[3,"西青","CN101030500"],[4,"北辰","CN101030600"],[5,"宁河","CN101030700"],[6,"和平","CN101030800"],[7,"静海","CN101030900"],[8,"津南","CN101031000"],[9,"滨海新区","CN101031100"],[10,"河东","CN101031200"],[11,"河西","CN101031300"],[12,"蓟州","CN101031400"],[13,"南开","CN101031500"],[14,"河北","CN101031600"],[15,"红桥","CN101031700"]
  ],
  "0_2":[
    [0,"上海市","CN101020100"]
  ],
  "0_2_0":[
    [0,"闵行","CN101020200"],[1,"宝山","CN101020300"],[2,"黄浦","CN101020400"],[3,"嘉定","CN101020500"],[4,"浦东新区","CN101020600"],[5,"金山","CN101020700"],[6,"青浦","CN101020800"],[7,"松江","CN101020900"],[8,"奉贤","CN101021000"],[9,"崇明","CN101021100"],[10,"徐汇","CN101021200"],[11,"长宁","CN101021300"],[12,"静安","CN101021400"],[13,"普陀","CN101021500"],[14,"虹口","CN101021600"],[15,"杨浦","CN101021700"]
  ],
  "0_3":[
    [0,"重庆市","CN101040100"]
  ],
  "0_3_0":[
    [0,"永川","CN101040200"],[1,"合川","CN101040300"],[2,"南川","CN101040400"],[3,"江津","CN101040500"],[4,"渝北","CN101040700"],[5,"北碚","CN101040800"],[6,"巴南","CN101040900"],[7,"长寿","CN101041000"],[8,"黔江","CN101041100"],[9,"渝中","CN101041200"],[10,"万州","CN101041300"],[11,"涪陵","CN101041400"],[12,"城口","CN101041600"],[13,"云阳","CN101041700"],[14,"巫溪","CN101041800"],[15,"奉节","CN101041900"],[16,"巫山","CN101042000"],[17,"潼南","CN101042100"],[18,"垫江","CN101042200"],[19,"梁平","CN101042300"],[20,"忠县","CN101042400"],[21,"石柱","CN101042500"],[22,"大足","CN101042600"],[23,"荣昌","CN101042700"],[24,"铜梁","CN101042800"],[25,"璧山","CN101042900"],[26,"丰都","CN101043000"],[27,"武隆","CN101043100"],[28,"彭水","CN101043200"],[29,"綦江","CN101043300"],[30,"酉阳","CN101043400"],[31,"大渡口","CN101043500"],[32,"秀山","CN101043600"],[33,"江北","CN101043700"],[34,"沙坪坝","CN101043800"],[35,"九龙坡","CN101043900"],[36,"南岸","CN101044000"],[37,"开州","CN101044100"]
  ],
  "0_4":[
    [0,"石家庄市","CN101090101"],[1,"保定市","CN101090201"],[2,"张家口市","CN101090301"],[3,"承德市","CN101090402"],[4,"唐山市","CN101090501"],[5,"廊坊市","CN101090601"],[6,"沧州市","CN101090701"],[7,"衡水市","CN101090801"],[8,"邢台市","CN101090901"],[9,"邯郸市","CN101091001"],[10,"秦皇岛市","CN101091101"],[11,"雄安新区","CN101091201"]
  ],
  "0_4_0":[
    [0,"井陉","CN101090102"],[1,"正定","CN101090103"],[2,"栾城","CN101090104"],[3,"行唐","CN101090105"],[4,"灵寿","CN101090106"],[5,"高邑","CN101090107"],[6,"深泽","CN101090108"],[7,"赞皇","CN101090109"],[8,"无极","CN101090110"],[9,"平山","CN101090111"],[10,"元氏","CN101090112"],[11,"赵县","CN101090113"],[12,"辛集","CN101090114"],[13,"藁城","CN101090115"],[14,"晋州","CN101090116"],[15,"新乐","CN101090117"],[16,"鹿泉","CN101090118"],[17,"长安","CN101090119"],[18,"桥西","CN101090120"],[19,"新华","CN101090121"],[20,"井陉矿区","CN101090122"],[21,"裕华","CN101090123"]
  ],
  "0_4_1":[
    [0,"满城","CN101090202"],[1,"阜平","CN101090203"],[2,"徐水","CN101090204"],[3,"唐县","CN101090205"],[4,"高阳","CN101090206"],[5,"竞秀","CN101090208"],[6,"涞源","CN101090209"],[7,"望都","CN101090210"],[8,"易县","CN101090212"],[9,"莲池","CN101090213"],[10,"曲阳","CN101090214"],[11,"蠡县","CN101090215"],[12,"顺平","CN101090216"],[13,"涿州","CN101090218"],[14,"定州","CN101090219"],[15,"安国","CN101090220"],[16,"高碑店","CN101090221"],[17,"涞水","CN101090222"],[18,"定兴","CN101090223"],[19,"清苑","CN101090224"],[20,"博野","CN101090225"],[21,"容城","CN101091202"],[22,"安新","CN101091203"],[23,"雄县","CN101091204"]
  ],
  "0_4_2":[
    [0,"宣化","CN101090302"],[1,"张北","CN101090303"],[2,"康保","CN101090304"],[3,"沽源","CN101090305"],[4,"尚义","CN101090306"],[5,"蔚县","CN101090307"],[6,"阳原","CN101090308"],[7,"怀安","CN101090309"],[8,"万全","CN101090310"],[9,"怀来","CN101090311"],[10,"涿鹿","CN101090312"],[11,"赤城","CN101090313"],[12,"崇礼","CN101090314"],[13,"桥东","CN101090315"],[14,"桥西","CN101090316"],[15,"下花园","CN101090317"]
  ],
  "0_4_3":[
    [0,"双桥","CN101090401"],[1,"承德县","CN101090403"],[2,"兴隆","CN101090404"],[3,"平泉","CN101090405"],[4,"滦平","CN101090406"],[5,"隆化","CN101090407"],[6,"丰宁","CN101090408"],[7,"宽城","CN101090409"],[8,"围场","CN101090410"],[9,"双滦","CN101090411"],[10,"鹰手营子矿","CN101090412"]
  ],
  "0_4_4":[
    [0,"丰南","CN101090502"],[1,"丰润","CN101090503"],[2,"滦州","CN101090504"],[3,"滦南","CN101090505"],[4,"乐亭","CN101090506"],[5,"迁西","CN101090507"],[6,"玉田","CN101090508"],[7,"曹妃甸","CN101090509"],[8,"遵化","CN101090510"],[9,"迁安","CN101090511"],[10,"路南","CN101090513"],[11,"路北","CN101090514"],[12,"古冶","CN101090515"],[13,"开平","CN101090516"]
  ],
  "0_4_5":[
    [0,"固安","CN101090602"],[1,"永清","CN101090603"],[2,"香河","CN101090604"],[3,"大城","CN101090605"],[4,"文安","CN101090606"],[5,"大厂","CN101090607"],[6,"霸州","CN101090608"],[7,"三河","CN101090609"],[8,"安次","CN101090610"],[9,"广阳","CN101090611"]
  ],
  "0_4_6":[
    [0,"青县","CN101090702"],[1,"东光","CN101090703"],[2,"海兴","CN101090704"],[3,"盐山","CN101090705"],[4,"肃宁","CN101090706"],[5,"南皮","CN101090707"],[6,"吴桥","CN101090708"],[7,"献县","CN101090709"],[8,"孟村","CN101090710"],[9,"泊头","CN101090711"],[10,"任丘","CN101090712"],[11,"黄骅","CN101090713"],[12,"河间","CN101090714"],[13,"新华","CN101090715"],[14,"沧县","CN101090716"],[15,"运河","CN101090717"]
  ],
  "0_4_7":[
    [0,"枣强","CN101090802"],[1,"武邑","CN101090803"],[2,"武强","CN101090804"],[3,"饶阳","CN101090805"],[4,"安平","CN101090806"],[5,"故城","CN101090807"],[6,"景县","CN101090808"],[7,"阜城","CN101090809"],[8,"冀州","CN101090810"],[9,"深州","CN101090811"],[10,"桃城","CN101090812"]
  ],
  "0_4_8":[
    [0,"临城","CN101090902"],[1,"襄都","CN101090903"],[2,"内丘","CN101090904"],[3,"柏乡","CN101090905"],[4,"隆尧","CN101090906"],[5,"南和","CN101090907"],[6,"宁晋","CN101090908"],[7,"巨鹿","CN101090909"],[8,"新河","CN101090910"],[9,"广宗","CN101090911"],[10,"平乡","CN101090912"],[11,"威县","CN101090913"],[12,"清河","CN101090914"],[13,"临西","CN101090915"],[14,"南宫","CN101090916"],[15,"沙河","CN101090917"],[16,"任泽","CN101090918"],[17,"信都","CN101090919"]
  ],
  "0_4_9":[
    [0,"峰峰","CN101091002"],[1,"临漳","CN101091003"],[2,"成安","CN101091004"],[3,"大名","CN101091005"],[4,"涉县","CN101091006"],[5,"磁县","CN101091007"],[6,"肥乡","CN101091008"],[7,"永年","CN101091009"],[8,"邱县","CN101091010"],[9,"鸡泽","CN101091011"],[10,"广平","CN101091012"],[11,"馆陶","CN101091013"],[12,"魏县","CN101091014"],[13,"曲周","CN101091015"],[14,"武安","CN101091016"],[15,"邯山","CN101091017"],[16,"丛台","CN101091018"],[17,"复兴","CN101091019"]
  ],
  "0_4_10":[
    [0,"青龙","CN101091102"],[1,"昌黎","CN101091103"],[2,"抚宁","CN101091104"],[3,"卢龙","CN101091105"],[4,"北戴河","CN101091106"],[5,"海港","CN101091107"],[6,"山海关","CN101091108"]
  ],
  "0_5":[
    [0,"太原市","CN101100101"],[1,"大同市","CN101100201"],[2,"阳泉市","CN101100301"],[3,"晋中市","CN101100401"],[4,"长治市","CN101100501"],[5,"晋城市","CN101100601"],[6,"临汾市","CN101100701"],[7,"运城市","CN101100801"],[8,"朔州市","CN101100901"],[9,"忻州市","CN101101001"],[10,"吕梁市","CN101101100"]
  ],
  "0_5_0":[
    [0,"清徐","CN101100102"],[1,"阳曲","CN101100103"],[2,"娄烦","CN101100104"],[3,"古交","CN101100105"],[4,"尖草坪区","CN101100106"],[5,"小店区","CN101100107"],[6,"迎泽","CN101100108"],[7,"杏花岭","CN101100109"],[8,"万柏林","CN101100110"],[9,"晋源","CN101100111"]
  ],
  "0_5_1":[
    [0,"阳高","CN101100202"],[1,"云州","CN101100203"],[2,"天镇","CN101100204"],[3,"广灵","CN101100205"],[4,"灵丘","CN101100206"],[5,"浑源","CN101100207"],[6,"左云","CN101100208"],[7,"云冈","CN101100209"],[9,"新荣","CN101100211"],[10,"平城","CN101100214"]
  ],
  "0_5_2":[
    [0,"盂县","CN101100302"],[1,"平定","CN101100303"],[2,"矿区","CN101100304"],[3,"郊区","CN101100305"],[4,"城区","CN101100306"]
  ],
  "0_5_3":[
    [0,"榆次","CN101100402"],[1,"榆社","CN101100403"],[2,"左权","CN101100404"],[3,"和顺","CN101100405"],[4,"昔阳","CN101100406"],[5,"寿阳","CN101100407"],[6,"太谷","CN101100408"],[7,"祁县","CN101100409"],[8,"平遥","CN101100410"],[9,"灵石","CN101100411"],[10,"介休","CN101100412"]
  ],
  "0_5_4":[
    [0,"黎城","CN101100502"],[1,"屯留","CN101100503"],[2,"潞城","CN101100504"],[3,"襄垣","CN101100505"],[4,"平顺","CN101100506"],[5,"武乡","CN101100507"],[6,"沁县","CN101100508"],[7,"长子","CN101100509"],[8,"沁源","CN101100510"],[9,"壶关","CN101100511"],[10,"潞州","CN101100512"],[11,"上党","CN101100513"]
  ],
  "0_5_5":[
    [0,"沁水","CN101100602"],[1,"阳城","CN101100603"],[2,"陵川","CN101100604"],[3,"高平","CN101100605"],[4,"泽州","CN101100606"],[5,"城区","CN101100607"]
  ],
  "0_5_6":[
    [0,"曲沃","CN101100702"],[1,"永和","CN101100703"],[2,"隰县","CN101100704"],[3,"大宁","CN101100705"],[4,"吉县","CN101100706"],[5,"襄汾","CN101100707"],[6,"蒲县","CN101100708"],[7,"汾西","CN101100709"],[8,"洪洞","CN101100710"],[9,"霍州","CN101100711"],[10,"乡宁","CN101100712"],[11,"翼城","CN101100713"],[12,"侯马","CN101100714"],[13,"浮山","CN101100715"],[14,"安泽","CN101100716"],[15,"古县","CN101100717"],[16,"尧都","CN101100718"]
  ],
  "0_5_7":[
    [0,"临猗","CN101100802"],[1,"稷山","CN101100803"],[2,"万荣","CN101100804"],[3,"河津","CN101100805"],[4,"新绛","CN101100806"],[5,"绛县","CN101100807"],[6,"闻喜","CN101100808"],[7,"垣曲","CN101100809"],[8,"永济","CN101100810"],[9,"芮城","CN101100811"],[10,"夏县","CN101100812"],[11,"平陆","CN101100813"],[12,"盐湖","CN101100814"]
  ],
  "0_5_8":[
    [0,"平鲁","CN101100902"],[1,"山阴","CN101100903"],[2,"右玉","CN101100904"],[3,"应县","CN101100905"],[4,"怀仁","CN101100906"],[5,"朔城","CN101100907"]
  ],
  "0_5_9":[
    [0,"定襄","CN101101002"],[1,"五台县","CN101101003"],[2,"河曲","CN101101004"],[3,"偏关","CN101101005"],[4,"神池","CN101101006"],[5,"宁武","CN101101007"],[6,"代县","CN101101008"],[7,"繁峙","CN101101009"],[9,"保德","CN101101011"],[10,"静乐","CN101101012"],[11,"岢岚","CN101101013"],[12,"五寨","CN101101014"],[13,"原平","CN101101015"],[14,"忻府","CN101101016"]
  ],
  "0_5_10":[
    [0,"离石","CN101101101"],[1,"临县","CN101101102"],[2,"兴县","CN101101103"],[3,"岚县","CN101101104"],[4,"柳林","CN101101105"],[5,"石楼","CN101101106"],[6,"方山","CN101101107"],[7,"交口","CN101101108"],[8,"中阳","CN101101109"],[9,"孝义","CN101101110"],[10,"汾阳","CN101101111"],[11,"文水","CN101101112"],[12,"交城","CN101101113"]
  ],
  "0_6":[
    [0,"呼和浩特市","CN101080101"],[1,"包头市","CN101080201"],[2,"乌海市","CN101080301"],[3,"乌兰察布市","CN101080405"],[4,"通辽市","CN101080501"],[5,"赤峰市","CN101080601"],[6,"鄂尔多斯市","CN101080701"],[7,"巴彦淖尔市","CN101080811"],[8,"锡林郭勒盟","CN101080902"],[9,"呼伦贝尔市","CN101081013"],[10,"兴安盟","CN101081108"],[11,"阿拉善盟","CN101081213"]
  ],
  "0_6_0":[
    [0,"土左旗","CN101080102"],[1,"托县","CN101080103"],[2,"和林","CN101080104"],[3,"清水河","CN101080105"],[4,"赛罕","CN101080106"],[5,"武川","CN101080107"],[6,"新城","CN101080108"],[7,"回民","CN101080109"],[8,"玉泉","CN101080110"]
  ],
  "0_6_1":[
    [0,"白云鄂博","CN101080202"],[2,"土右旗","CN101080204"],[3,"固阳","CN101080205"],[4,"达茂旗","CN101080206"],[6,"东河","CN101080208"],[7,"昆都仑","CN101080209"],[8,"青山","CN101080210"],[9,"石拐","CN101080211"],[10,"九原","CN101080212"]
  ],
  "0_6_2":[
    [0,"海勃湾","CN101080302"],[1,"海南","CN101080303"],[2,"乌达","CN101080304"]
  ],
  "0_6_3":[
    [0,"集宁","CN101080401"],[1,"卓资","CN101080402"],[2,"化德","CN101080403"],[3,"商都","CN101080404"],[4,"兴和","CN101080406"],[5,"凉城","CN101080407"],[6,"察右前旗","CN101080408"],[7,"察右中旗","CN101080409"],[8,"察右后旗","CN101080410"],[9,"四子王旗","CN101080411"],[10,"丰镇","CN101080412"]
  ],
  "0_6_4":[
    [1,"科左中旗","CN101080503"],[2,"科左后旗","CN101080504"],[4,"开鲁","CN101080506"],[5,"库伦","CN101080507"],[6,"奈曼","CN101080508"],[7,"扎鲁特","CN101080509"],[8,"科尔沁","CN101080510"],[10,"霍林郭勒","CN101080512"]
  ],
  "0_6_5":[
    [0,"红山","CN101080602"],[1,"阿鲁旗","CN101080603"],[2,"巴林左旗","CN101080605"],[3,"巴林右旗","CN101080606"],[4,"林西","CN101080607"],[5,"克什克腾","CN101080608"],[6,"翁牛特","CN101080609"],[8,"喀喇沁","CN101080611"],[10,"宁城","CN101080613"],[11,"敖汉","CN101080614"],[12,"元宝山","CN101080616"],[13,"松山","CN101080617"]
  ],
  "0_6_6":[
    [0,"达拉特","CN101080703"],[1,"准格尔","CN101080704"],[2,"鄂前旗","CN101080705"],[5,"鄂托克","CN101080708"],[6,"杭锦旗","CN101080709"],[7,"乌审旗","CN101080710"],[8,"伊金霍洛","CN101080711"],[10,"东胜","CN101080713"],[11,"康巴什","CN101080714"]
  ],
  "0_6_7":[
    [0,"临河","CN101080801"],[1,"五原","CN101080802"],[2,"磴口","CN101080803"],[3,"乌前旗","CN101080804"],[5,"乌中旗","CN101080806"],[6,"乌后旗","CN101080807"],[9,"杭锦后旗","CN101080810"]
  ],
  "0_6_8":[
    [0,"锡林浩特","CN101080901"],[1,"二连浩特","CN101080903"],[2,"阿巴嘎","CN101080904"],[3,"苏左旗","CN101080906"],[4,"苏右旗","CN101080907"],[6,"东乌旗","CN101080909"],[7,"西乌旗","CN101080910"],[8,"太仆寺","CN101080911"],[9,"镶黄旗","CN101080912"],[10,"正镶白旗","CN101080913"],[11,"正蓝旗","CN101080914"],[12,"多伦","CN101080915"]
  ],
  "0_6_9":[
    [0,"海拉尔","CN101081001"],[2,"阿荣旗","CN101081003"],[3,"莫力达瓦","CN101081004"],[4,"鄂伦春旗","CN101081005"],[5,"鄂温克旗","CN101081006"],[6,"陈旗","CN101081007"],[7,"新左旗","CN101081008"],[8,"新右旗","CN101081009"],[9,"满洲里","CN101081010"],[10,"牙克石","CN101081011"],[11,"扎兰屯","CN101081012"],[12,"额尔古纳","CN101081014"],[13,"根河","CN101081015"],[15,"扎赉诺尔","CN101081017"]
  ],
  "0_6_10":[
    [0,"乌兰浩特","CN101081101"],[1,"阿尔山","CN101081102"],[2,"科右中旗","CN101081103"],[4,"扎赉特","CN101081105"],[6,"突泉","CN101081107"],[7,"科右前旗","CN101081109"]
  ],
  "0_6_11":[
    [0,"阿左旗","CN101081201"],[1,"阿右旗","CN101081202"],[2,"额济纳","CN101081203"]
  ],
  "0_7":[
    [0,"沈阳市","CN101070101"],[1,"大连市","CN101070201"],[2,"鞍山市","CN101070301"],[3,"抚顺市","CN101070401"],[4,"本溪市","CN101070501"],[5,"丹东市","CN101070601"],[6,"锦州市","CN101070701"],[7,"营口市","CN101070801"],[8,"阜新市","CN101070901"],[9,"辽阳市","CN101071001"],[10,"铁岭市","CN101071101"],[11,"朝阳市","CN101071201"],[12,"盘锦市","CN101071301"],[13,"葫芦岛市","CN101071401"]
  ],
  "0_7_0":[
    [0,"浑南","CN101070102"],[1,"辽中","CN101070103"],[2,"康平","CN101070104"],[3,"法库","CN101070105"],[4,"新民","CN101070106"],[5,"和平","CN101070107"],[6,"沈河","CN101070108"],[7,"大东","CN101070109"],[8,"皇姑","CN101070110"],[9,"铁西","CN101070111"],[10,"苏家屯","CN101070112"],[11,"沈北新区","CN101070113"],[12,"于洪","CN101070114"]
  ],
  "0_7_1":[
    [0,"瓦房店","CN101070202"],[1,"金州","CN101070203"],[2,"普兰店","CN101070204"],[3,"旅顺","CN101070205"],[4,"长海","CN101070206"],[5,"庄河","CN101070207"],[6,"中山","CN101070208"],[7,"西岗","CN101070209"],[8,"沙河口","CN101070210"],[9,"甘井子","CN101070211"]
  ],
  "0_7_2":[
    [0,"台安","CN101070302"],[1,"岫岩","CN101070303"],[2,"海城","CN101070304"],[3,"铁东","CN101070305"],[4,"铁西","CN101070306"],[5,"立山","CN101070307"],[6,"千山","CN101070308"]
  ],
  "0_7_3":[
    [0,"新宾","CN101070402"],[1,"清原","CN101070403"],[2,"新抚","CN101070405"],[3,"东洲","CN101070406"],[4,"望花","CN101070407"],[5,"顺城","CN101070408"],[6,"抚顺县","CN101070409"]
  ],
  "0_7_4":[
    [0,"本溪县","CN101070502"],[1,"平山","CN101070503"],[2,"桓仁","CN101070504"],[3,"溪湖","CN101070505"],[4,"明山","CN101070506"],[5,"南芬","CN101070507"]
  ],
  "0_7_5":[
    [0,"凤城","CN101070602"],[1,"宽甸","CN101070603"],[2,"东港","CN101070604"],[3,"元宝","CN101070605"],[4,"振兴","CN101070606"],[5,"振安","CN101070607"]
  ],
  "0_7_6":[
    [0,"凌海","CN101070702"],[1,"古塔","CN101070703"],[2,"义县","CN101070704"],[3,"黑山","CN101070705"],[4,"北镇","CN101070706"],[5,"凌河","CN101070707"],[6,"太和","CN101070708"]
  ],
  "0_7_7":[
    [0,"大石桥","CN101070802"],[1,"盖州","CN101070803"],[2,"站前","CN101070804"],[3,"西市","CN101070805"],[4,"鲅鱼圈","CN101070806"],[5,"老边","CN101070807"]
  ],
  "0_7_8":[
    [0,"彰武","CN101070902"],[1,"海州","CN101070903"],[2,"新邱","CN101070904"],[3,"太平","CN101070905"],[4,"清河门","CN101070906"],[5,"细河","CN101070907"],[6,"阜新县","CN101070908"]
  ],
  "0_7_9":[
    [0,"辽阳县","CN101071002"],[1,"灯塔","CN101071003"],[2,"弓长岭","CN101071004"],[3,"白塔","CN101071005"],[4,"文圣","CN101071006"],[5,"宏伟","CN101071007"],[6,"太子河","CN101071008"]
  ],
  "0_7_10":[
    [0,"开原","CN101071102"],[1,"昌图","CN101071103"],[2,"西丰","CN101071104"],[3,"调兵山","CN101071105"],[4,"银州","CN101071106"],[5,"清河","CN101071107"],[6,"铁岭县","CN101071108"]
  ],
  "0_7_11":[
    [0,"双塔","CN101071202"],[1,"凌源","CN101071203"],[2,"喀左","CN101071204"],[3,"北票","CN101071205"],[4,"龙城","CN101071206"],[5,"建平县","CN101071207"],[6,"朝阳县","CN101071208"]
  ],
  "0_7_12":[
    [0,"大洼","CN101071302"],[1,"盘山","CN101071303"],[2,"双台子","CN101071304"],[3,"兴隆台","CN101071305"]
  ],
  "0_7_13":[
    [0,"建昌","CN101071402"],[1,"绥中","CN101071403"],[2,"兴城","CN101071404"],[3,"连山","CN101071405"],[4,"龙港","CN101071406"],[5,"南票","CN101071407"]
  ],
  "0_8":[
    [0,"长春市","CN101060101"],[1,"吉林市","CN101060201"],[2,"延边州","CN101060306"],[3,"四平市","CN101060401"],[4,"通化市","CN101060501"],[5,"白城市","CN101060601"],[6,"辽源市","CN101060701"],[7,"松原市","CN101060801"],[8,"白山市","CN101060901"]
  ],
  "0_8_0":[
    [0,"农安","CN101060102"],[1,"德惠","CN101060103"],[2,"九台","CN101060104"],[3,"榆树","CN101060105"],[4,"双阳","CN101060106"],[5,"二道","CN101060107"],[6,"南关","CN101060108"],[7,"宽城","CN101060109"],[8,"朝阳","CN101060110"],[9,"绿园","CN101060111"]
  ],
  "0_8_1":[
    [0,"舒兰","CN101060202"],[1,"永吉","CN101060203"],[2,"蛟河","CN101060204"],[3,"磐石","CN101060205"],[4,"桦甸","CN101060206"],[5,"昌邑","CN101060207"],[6,"龙潭","CN101060208"],[7,"船营","CN101060209"],[8,"丰满","CN101060210"]
  ],
  "0_8_2":[
    [0,"延吉","CN101060301"],[1,"敦化","CN101060302"],[2,"安图","CN101060303"],[3,"汪清","CN101060304"],[4,"和龙","CN101060305"],[5,"龙井","CN101060307"],[6,"珲春","CN101060308"],[7,"图们","CN101060309"]
  ],
  "0_8_3":[
    [0,"双辽","CN101060402"],[1,"梨树","CN101060403"],[2,"公主岭","CN101060404"],[3,"伊通","CN101060405"],[4,"铁西","CN101060406"],[5,"铁东","CN101060407"]
  ],
  "0_8_4":[
    [0,"梅河口","CN101060502"],[1,"柳河","CN101060503"],[2,"辉南","CN101060504"],[3,"集安","CN101060505"],[4,"通化县","CN101060506"],[5,"东昌","CN101060507"],[6,"二道江","CN101060508"]
  ],
  "0_8_5":[
    [0,"洮南","CN101060602"],[1,"大安","CN101060603"],[2,"镇赉","CN101060604"],[3,"通榆","CN101060605"],[4,"洮北","CN101060606"]
  ],
  "0_8_6":[
    [0,"东丰","CN101060702"],[1,"东辽","CN101060703"],[2,"龙山","CN101060704"],[3,"西安","CN101060705"]
  ],
  "0_8_7":[
    [0,"乾安","CN101060802"],[1,"前郭","CN101060803"],[2,"长岭","CN101060804"],[3,"扶余","CN101060805"],[4,"宁江","CN101060806"]
  ],
  "0_8_8":[
    [0,"靖宇","CN101060902"],[1,"临江","CN101060903"],[3,"长白","CN101060905"],[4,"抚松","CN101060906"],[5,"江源","CN101060907"],[6,"浑江","CN101060908"]
  ],
  "0_9":[
    [0,"哈尔滨市","CN101050101"],[1,"齐齐哈尔市","CN101050201"],[2,"牡丹江市","CN101050301"],[3,"佳木斯市","CN101050401"],[4,"绥化市","CN101050501"],[5,"黑河市","CN101050601"],[6,"大兴安岭","CN101050701"],[7,"伊春市","CN101050801"],[8,"大庆市","CN101050901"],[9,"七台河市","CN101051002"],[10,"鸡西市","CN101051101"],[11,"鹤岗市","CN101051201"],[12,"双鸭山市","CN101051301"]
  ],
  "0_9_0":[
    [0,"双城","CN101050102"],[1,"呼兰","CN101050103"],[2,"阿城","CN101050104"],[3,"宾县","CN101050105"],[4,"依兰","CN101050106"],[5,"巴彦","CN101050107"],[6,"通河","CN101050108"],[7,"方正","CN101050109"],[8,"延寿","CN101050110"],[9,"尚志","CN101050111"],[10,"五常","CN101050112"],[11,"木兰","CN101050113"],[12,"道里","CN101050114"],[13,"南岗","CN101050115"],[14,"道外","CN101050116"],[15,"平房","CN101050117"],[16,"松北","CN101050118"],[17,"香坊","CN101050119"]
  ],
  "0_9_1":[
    [0,"讷河","CN101050202"],[1,"龙江","CN101050203"],[2,"甘南","CN101050204"],[3,"富裕","CN101050205"],[4,"依安","CN101050206"],[5,"拜泉","CN101050207"],[6,"克山","CN101050208"],[7,"克东","CN101050209"],[8,"泰来","CN101050210"],[9,"龙沙","CN101050211"],[10,"建华","CN101050212"],[11,"铁锋","CN101050213"],[12,"昂昂溪","CN101050214"],[13,"富拉尔基","CN101050215"],[14,"碾子山","CN101050216"],[15,"梅里斯","CN101050217"]
  ],
  "0_9_2":[
    [0,"海林","CN101050302"],[1,"穆棱","CN101050303"],[2,"林口","CN101050304"],[3,"绥芬河","CN101050305"],[4,"宁安","CN101050306"],[5,"东宁","CN101050307"],[6,"东安","CN101050308"],[7,"阳明","CN101050309"],[8,"爱民","CN101050310"],[9,"西安","CN101050311"]
  ],
  "0_9_3":[
    [0,"汤原","CN101050402"],[1,"抚远","CN101050403"],[2,"桦川","CN101050404"],[3,"桦南","CN101050405"],[4,"同江","CN101050406"],[5,"富锦","CN101050407"],[6,"向阳","CN101050408"],[7,"前进","CN101050409"],[8,"东风","CN101050410"],[9,"郊区","CN101050411"]
  ],
  "0_9_4":[
    [0,"肇东","CN101050502"],[1,"安达","CN101050503"],[2,"海伦","CN101050504"],[3,"明水","CN101050505"],[4,"望奎","CN101050506"],[5,"兰西","CN101050507"],[6,"青冈","CN101050508"],[7,"庆安","CN101050509"],[8,"绥棱","CN101050510"],[9,"北林","CN101050511"]
  ],
  "0_9_5":[
    [0,"嫩江","CN101050602"],[1,"孙吴","CN101050603"],[2,"逊克","CN101050604"],[3,"五大连池","CN101050605"],[4,"北安","CN101050606"],[5,"爱辉","CN101050607"]
  ],
  "0_9_6":[
    [0,"塔河","CN101050702"],[1,"漠河","CN101050703"],[2,"呼玛","CN101050704"]
  ],
  "0_9_7":[
    [2,"铁力","CN101050804"],[3,"嘉荫","CN101050805"],[4,"南岔","CN101050806"],[5,"友好","CN101050807"],[6,"金林","CN101050808"],[9,"伊美","CN101050811"],[11,"乌翠","CN101050813"],[12,"汤旺县","CN101050814"],[13,"大箐山县","CN101050815"],[14,"丰林","CN101050816"]
  ],
  "0_9_8":[
    [0,"林甸","CN101050902"],[1,"肇州","CN101050903"],[2,"肇源","CN101050904"],[3,"杜尔伯特","CN101050905"],[4,"萨尔图","CN101050906"],[5,"龙凤","CN101050907"],[6,"让胡路","CN101050908"],[7,"红岗","CN101050909"],[8,"大同","CN101050910"]
  ],
  "0_9_9":[
    [0,"新兴","CN101051001"],[1,"勃利","CN101051003"],[2,"桃山","CN101051004"],[3,"茄子河","CN101051005"]
  ],
  "0_9_10":[
    [0,"虎林","CN101051102"],[1,"密山","CN101051103"],[2,"鸡东","CN101051104"],[3,"鸡冠","CN101051105"],[4,"恒山","CN101051106"],[5,"滴道","CN101051107"],[6,"梨树","CN101051108"],[7,"城子河","CN101051109"],[8,"麻山","CN101051110"]
  ],
  "0_9_11":[
    [0,"绥滨","CN101051202"],[1,"萝北","CN101051203"],[2,"向阳","CN101051204"],[3,"工农","CN101051205"],[4,"南山","CN101051206"],[5,"兴安","CN101051207"],[6,"东山","CN101051208"],[7,"兴山","CN101051209"]
  ],
  "0_9_12":[
    [0,"集贤","CN101051302"],[1,"宝清","CN101051303"],[2,"饶河","CN101051304"],[3,"友谊","CN101051305"],[4,"尖山","CN101051306"],[5,"岭东","CN101051307"],[6,"四方台","CN101051308"],[7,"宝山","CN101051309"]
  ],
  "0_10":[
    [0,"南京市","CN101190101"],[1,"无锡市","CN101190201"],[2,"镇江市","CN101190301"],[3,"苏州市","CN101190401"],[4,"南通市","CN101190501"],[5,"扬州市","CN101190601"],[6,"盐城市","CN101190701"],[7,"徐州市","CN101190801"],[8,"淮安市","CN101190901"],[9,"连云港市","CN101191001"],[10,"常州市","CN101191101"],[11,"泰州市","CN101191201"],[12,"宿迁市","CN101191301"]
  ],
  "0_10_0":[
    [0,"溧水","CN101190102"],[1,"高淳","CN101190103"],[2,"江宁","CN101190104"],[3,"六合","CN101190105"],[4,"浦口","CN101190107"],[5,"玄武","CN101190108"],[6,"秦淮","CN101190109"],[7,"建邺","CN101190110"],[8,"鼓楼","CN101190111"],[9,"栖霞","CN101190112"],[10,"雨花台","CN101190113"]
  ],
  "0_10_1":[
    [0,"江阴","CN101190202"],[1,"宜兴","CN101190203"],[2,"锡山","CN101190204"],[3,"惠山","CN101190205"],[4,"滨湖","CN101190206"],[5,"梁溪","CN101190207"],[6,"新吴","CN101190208"]
  ],
  "0_10_2":[
    [0,"丹阳","CN101190302"],[1,"扬中","CN101190303"],[2,"句容","CN101190304"],[3,"丹徒","CN101190305"],[4,"京口","CN101190306"],[5,"润州","CN101190307"]
  ],
  "0_10_3":[
    [0,"常熟","CN101190402"],[1,"张家港","CN101190403"],[2,"昆山","CN101190404"],[3,"吴中","CN101190405"],[4,"虎丘","CN101190406"],[5,"吴江","CN101190407"],[6,"太仓","CN101190408"],[7,"相城","CN101190409"],[8,"姑苏","CN101190410"]
  ],
  "0_10_4":[
    [0,"海安","CN101190502"],[1,"如皋","CN101190503"],[2,"如东","CN101190504"],[3,"崇川","CN101190505"],[5,"启东","CN101190507"],[6,"海门","CN101190508"],[7,"通州","CN101190509"]
  ],
  "0_10_5":[
    [0,"宝应","CN101190602"],[1,"仪征","CN101190603"],[2,"高邮","CN101190604"],[3,"江都","CN101190605"],[4,"邗江","CN101190606"],[5,"广陵","CN101190607"]
  ],
  "0_10_6":[
    [0,"响水","CN101190702"],[1,"滨海","CN101190703"],[2,"阜宁","CN101190704"],[3,"射阳","CN101190705"],[4,"建湖","CN101190706"],[5,"东台","CN101190707"],[6,"大丰","CN101190708"],[7,"盐都","CN101190709"],[8,"亭湖","CN101190710"]
  ],
  "0_10_7":[
    [0,"铜山","CN101190802"],[1,"丰县","CN101190803"],[2,"沛县","CN101190804"],[3,"邳州","CN101190805"],[4,"睢宁","CN101190806"],[5,"新沂","CN101190807"],[6,"鼓楼","CN101190808"],[7,"云龙","CN101190809"],[8,"贾汪","CN101190810"],[9,"泉山","CN101190811"]
  ],
  "0_10_8":[
    [0,"金湖","CN101190902"],[1,"盱眙","CN101190903"],[2,"洪泽","CN101190904"],[3,"涟水","CN101190905"],[4,"淮阴区","CN101190906"],[5,"清江浦","CN101190907"],[6,"淮安区","CN101190908"]
  ],
  "0_10_9":[
    [0,"东海","CN101191002"],[1,"赣榆","CN101191003"],[2,"灌云","CN101191004"],[3,"灌南","CN101191005"],[4,"海州","CN101191006"],[5,"连云","CN101191007"]
  ],
  "0_10_10":[
    [0,"溧阳","CN101191102"],[1,"金坛","CN101191103"],[2,"武进","CN101191104"],[3,"天宁","CN101191105"],[4,"钟楼","CN101191106"],[5,"新北","CN101191107"]
  ],
  "0_10_11":[
    [0,"兴化","CN101191202"],[1,"泰兴","CN101191203"],[2,"姜堰","CN101191204"],[3,"靖江","CN101191205"],[4,"海陵","CN101191206"],[5,"高港","CN101191207"]
  ],
  "0_10_12":[
    [0,"沭阳","CN101191302"],[1,"泗阳","CN101191303"],[2,"泗洪","CN101191304"],[3,"宿豫","CN101191305"],[4,"宿城","CN101191306"]
  ],
  "0_11":[
    [0,"杭州市","CN101210101"],[1,"湖州市","CN101210201"],[2,"嘉兴市","CN101210301"],[3,"宁波市","CN101210401"],[4,"绍兴市","CN101210507"],[5,"台州市","CN101210601"],[6,"温州市","CN101210701"],[7,"丽水市","CN101210801"],[8,"金华市","CN101210901"],[9,"衢州市","CN101211001"],[10,"舟山市","CN101211101"]
  ],
  "0_11_0":[
    [0,"萧山","CN101210102"],[1,"桐庐","CN101210103"],[2,"淳安","CN101210104"],[3,"建德","CN101210105"],[4,"余杭","CN101210106"],[5,"临安","CN101210107"],[6,"富阳","CN101210108"],[7,"上城","CN101210109"],[9,"钱塘","CN101210111"],[10,"拱墅","CN101210112"],[11,"西湖","CN101210113"],[12,"滨江","CN101210114"],[13,"临平","CN101210115"]
  ],
  "0_11_1":[
    [0,"长兴","CN101210202"],[1,"安吉","CN101210203"],[2,"德清","CN101210204"],[3,"吴兴","CN101210205"],[4,"南浔","CN101210206"]
  ],
  "0_11_2":[
    [0,"嘉善","CN101210302"],[1,"海宁","CN101210303"],[2,"桐乡","CN101210304"],[3,"平湖","CN101210305"],[4,"海盐","CN101210306"],[5,"南湖","CN101210307"],[6,"秀洲","CN101210308"]
  ],
  "0_11_3":[
    [0,"海曙","CN101210402"],[1,"慈溪","CN101210403"],[2,"余姚","CN101210404"],[3,"奉化","CN101210405"],[4,"象山","CN101210406"],[5,"宁海","CN101210408"],[6,"江北","CN101210409"],[7,"北仑","CN101210410"],[8,"鄞州","CN101210411"],[9,"镇海","CN101210412"]
  ],
  "0_11_4":[
    [0,"越城","CN101210501"],[1,"诸暨","CN101210502"],[2,"上虞","CN101210503"],[3,"新昌","CN101210504"],[4,"嵊州","CN101210505"],[5,"柯桥","CN101210506"]
  ],
  "0_11_5":[
    [0,"玉环","CN101210603"],[1,"三门","CN101210604"],[2,"天台","CN101210605"],[3,"仙居","CN101210606"],[4,"温岭","CN101210607"],[5,"临海","CN101210610"],[6,"椒江","CN101210611"],[7,"黄岩","CN101210612"],[8,"路桥","CN101210613"]
  ],
  "0_11_6":[
    [0,"泰顺","CN101210702"],[1,"文成","CN101210703"],[2,"平阳","CN101210704"],[3,"瑞安","CN101210705"],[4,"洞头","CN101210706"],[5,"乐清","CN101210707"],[6,"永嘉","CN101210708"],[7,"苍南","CN101210709"],[8,"鹿城","CN101210710"],[9,"龙湾","CN101210711"],[10,"瓯海","CN101210712"],[11,"龙港","CN101210713"]
  ],
  "0_11_7":[
    [0,"遂昌","CN101210802"],[1,"龙泉","CN101210803"],[2,"缙云","CN101210804"],[3,"青田","CN101210805"],[4,"云和","CN101210806"],[5,"庆元","CN101210807"],[6,"松阳","CN101210808"],[7,"景宁","CN101210809"],[8,"莲都","CN101210810"]
  ],
  "0_11_8":[
    [0,"浦江","CN101210902"],[1,"兰溪","CN101210903"],[2,"义乌","CN101210904"],[3,"东阳","CN101210905"],[4,"武义","CN101210906"],[5,"永康","CN101210907"],[6,"磐安","CN101210908"],[7,"婺城","CN101210909"],[8,"金东","CN101210910"]
  ],
  "0_11_9":[
    [0,"常山","CN101211002"],[1,"开化","CN101211003"],[2,"龙游","CN101211004"],[3,"江山","CN101211005"],[4,"衢江","CN101211006"],[5,"柯城","CN101211007"]
  ],
  "0_11_10":[
    [0,"嵊泗","CN101211102"],[1,"岱山","CN101211104"],[2,"普陀","CN101211105"],[3,"定海","CN101211106"]
  ],
  "0_12":[
    [0,"合肥市","CN101220101"],[1,"蚌埠市","CN101220201"],[2,"芜湖市","CN101220301"],[3,"淮南市","CN101220401"],[4,"马鞍山市","CN101220501"],[5,"安庆市","CN101220601"],[6,"宿州市","CN101220701"],[7,"阜阳市","CN101220801"],[8,"亳州市","CN101220901"],[9,"黄山市","CN101221001"],[10,"滁州市","CN101221101"],[11,"淮北市","CN101221201"],[12,"铜陵市","CN101221301"],[13,"宣城市","CN101221401"],[14,"六安市","CN101221501"],[15,"池州市","CN101221701"]
  ],
  "0_12_0":[
    [0,"长丰","CN101220102"],[1,"肥东","CN101220103"],[2,"肥西","CN101220104"],[3,"巢湖","CN101220105"],[4,"庐江","CN101220106"],[5,"瑶海","CN101220107"],[6,"庐阳","CN101220108"],[7,"蜀山","CN101220109"],[8,"包河","CN101220110"]
  ],
  "0_12_1":[
    [0,"怀远","CN101220202"],[1,"固镇","CN101220203"],[2,"五河","CN101220204"],[3,"龙子湖","CN101220205"],[4,"蚌山","CN101220206"],[5,"禹会","CN101220207"],[6,"淮上","CN101220208"]
  ],
  "0_12_2":[
    [0,"繁昌","CN101220302"],[1,"湾沚","CN101220303"],[2,"南陵","CN101220304"],[3,"无为","CN101220305"],[4,"镜湖","CN101220306"],[5,"弋江","CN101220307"],[6,"鸠江","CN101220308"]
  ],
  "0_12_3":[
    [0,"凤台","CN101220402"],[1,"潘集","CN101220403"],[2,"大通","CN101220404"],[3,"田家庵","CN101220405"],[4,"谢家集","CN101220406"],[5,"八公山","CN101220407"],[6,"寿县","CN101220408"]
  ],
  "0_12_4":[
    [0,"当涂","CN101220502"],[1,"含山","CN101220503"],[2,"和县","CN101220504"],[3,"花山","CN101220505"],[4,"雨山","CN101220506"],[5,"博望","CN101220507"]
  ],
  "0_12_5":[
    [0,"太湖","CN101220603"],[1,"潜山","CN101220604"],[2,"怀宁","CN101220605"],[3,"宿松","CN101220606"],[4,"望江","CN101220607"],[5,"岳西","CN101220608"],[6,"桐城","CN101220609"],[7,"迎江","CN101220610"],[8,"大观","CN101220611"],[9,"宜秀","CN101220612"]
  ],
  "0_12_6":[
    [0,"砀山","CN101220702"],[1,"灵璧","CN101220703"],[2,"泗县","CN101220704"],[3,"萧县","CN101220705"],[4,"埇桥","CN101220706"]
  ],
  "0_12_7":[
    [0,"阜南","CN101220802"],[1,"颍上","CN101220803"],[2,"临泉","CN101220804"],[3,"界首","CN101220805"],[4,"太和","CN101220806"],[5,"颍州","CN101220807"],[6,"颍东","CN101220808"],[7,"颍泉","CN101220809"]
  ],
  "0_12_8":[
    [0,"涡阳","CN101220902"],[1,"利辛","CN101220903"],[2,"蒙城","CN101220904"],[3,"谯城","CN101220905"]
  ],
  "0_12_9":[
    [0,"黄山区","CN101221002"],[1,"屯溪","CN101221003"],[2,"祁门","CN101221004"],[3,"黟县","CN101221005"],[4,"歙县","CN101221006"],[5,"休宁","CN101221007"],[7,"徽州","CN101221009"]
  ],
  "0_12_10":[
    [0,"凤阳","CN101221102"],[1,"明光","CN101221103"],[2,"定远","CN101221104"],[3,"全椒","CN101221105"],[4,"来安","CN101221106"],[5,"天长","CN101221107"],[6,"琅琊","CN101221108"],[7,"南谯","CN101221109"]
  ],
  "0_12_11":[
    [0,"濉溪","CN101221202"],[1,"杜集","CN101221203"],[2,"相山","CN101221204"],[3,"烈山","CN101221205"]
  ],
  "0_12_12":[
    [0,"铜官","CN101221302"],[1,"义安","CN101221303"],[2,"郊区","CN101221304"],[3,"枞阳","CN101221305"]
  ],
  "0_12_13":[
    [0,"泾县","CN101221402"],[1,"旌德","CN101221403"],[2,"宁国","CN101221404"],[3,"绩溪","CN101221405"],[4,"广德","CN101221406"],[5,"郎溪","CN101221407"],[6,"宣州","CN101221408"]
  ],
  "0_12_14":[
    [0,"霍邱","CN101221502"],[1,"金安","CN101221504"],[2,"金寨","CN101221505"],[3,"霍山","CN101221506"],[4,"舒城","CN101221507"],[5,"裕安","CN101221508"],[6,"叶集","CN101221509"]
  ],
  "0_12_15":[
    [0,"东至","CN101221702"],[1,"青阳","CN101221703"],[3,"石台","CN101221705"],[4,"贵池","CN101221706"]
  ],
  "0_13":[
    [0,"福州市","CN101230101"],[1,"厦门市","CN101230201"],[2,"宁德市","CN101230301"],[3,"莆田市","CN101230401"],[4,"泉州市","CN101230501"],[5,"漳州市","CN101230601"],[6,"龙岩市","CN101230701"],[7,"三明市","CN101230801"],[8,"南平市","CN101230901"],[9,"钓鱼岛","CN101231001"]
  ],
  "0_13_0":[
    [0,"闽清","CN101230102"],[1,"闽侯","CN101230103"],[2,"罗源","CN101230104"],[3,"连江","CN101230105"],[4,"鼓楼","CN101230106"],[5,"永泰","CN101230107"],[6,"平潭","CN101230108"],[7,"台江","CN101230109"],[8,"长乐","CN101230110"],[9,"福清","CN101230111"],[10,"仓山","CN101230112"],[11,"马尾","CN101230113"],[12,"晋安","CN101230114"]
  ],
  "0_13_1":[
    [0,"同安","CN101230202"],[1,"思明","CN101230203"],[2,"海沧","CN101230204"],[3,"湖里","CN101230205"],[4,"集美","CN101230206"],[5,"翔安","CN101230207"]
  ],
  "0_13_2":[
    [0,"古田","CN101230302"],[1,"霞浦","CN101230303"],[2,"寿宁","CN101230304"],[3,"周宁","CN101230305"],[4,"福安","CN101230306"],[5,"柘荣","CN101230307"],[6,"福鼎","CN101230308"],[7,"屏南","CN101230309"],[8,"蕉城","CN101230310"]
  ],
  "0_13_3":[
    [0,"仙游","CN101230402"],[1,"涵江","CN101230404"],[2,"秀屿","CN101230405"],[3,"荔城","CN101230406"],[4,"城厢","CN101230407"]
  ],
  "0_13_4":[
    [0,"安溪","CN101230502"],[1,"金门","CN101230503"],[2,"永春","CN101230504"],[3,"德化","CN101230505"],[4,"南安","CN101230506"],[6,"惠安","CN101230508"],[7,"晋江","CN101230509"],[8,"石狮","CN101230510"],[9,"鲤城","CN101230511"],[10,"丰泽","CN101230512"],[11,"洛江","CN101230513"],[12,"泉港","CN101230514"]
  ],
  "0_13_5":[
    [0,"长泰","CN101230602"],[1,"南靖","CN101230603"],[2,"平和","CN101230604"],[3,"龙海","CN101230605"],[4,"漳浦","CN101230606"],[5,"诏安","CN101230607"],[6,"东山","CN101230608"],[7,"云霄","CN101230609"],[8,"华安","CN101230610"],[9,"芗城","CN101230611"],[10,"龙文","CN101230612"]
  ],
  "0_13_6":[
    [0,"长汀","CN101230702"],[1,"连城","CN101230703"],[2,"武平","CN101230704"],[3,"上杭","CN101230705"],[4,"永定","CN101230706"],[5,"漳平","CN101230707"],[6,"新罗","CN101230708"]
  ],
  "0_13_7":[
    [0,"宁化","CN101230802"],[1,"清流","CN101230803"],[2,"泰宁","CN101230804"],[3,"将乐","CN101230805"],[4,"建宁","CN101230806"],[5,"明溪","CN101230807"],[6,"沙县","CN101230808"],[7,"尤溪","CN101230809"],[8,"永安","CN101230810"],[9,"大田","CN101230811"],[10,"梅列","CN101230812"],[11,"三元","CN101230813"]
  ],
  "0_13_8":[
    [0,"顺昌","CN101230902"],[1,"光泽","CN101230903"],[2,"邵武","CN101230904"],[3,"武夷山","CN101230905"],[4,"浦城","CN101230906"],[5,"建阳","CN101230907"],[6,"松溪","CN101230908"],[7,"政和","CN101230909"],[8,"建瓯","CN101230910"],[9,"延平","CN101230911"]
  ],
  "0_14":[
    [0,"南昌市","CN101240101"],[1,"九江市","CN101240201"],[2,"上饶市","CN101240301"],[3,"抚州市","CN101240401"],[4,"宜春市","CN101240501"],[5,"吉安市","CN101240601"],[6,"赣州市","CN101240701"],[7,"景德镇市","CN101240801"],[8,"萍乡市","CN101240901"],[9,"新余市","CN101241001"],[10,"鹰潭市","CN101241101"]
  ],
  "0_14_0":[
    [0,"新建","CN101240102"],[1,"南昌县","CN101240103"],[2,"安义","CN101240104"],[3,"进贤","CN101240105"],[4,"东湖","CN101240106"],[5,"西湖","CN101240107"],[6,"青云谱","CN101240108"],[7,"红谷滩","CN101240109"],[8,"青山湖","CN101240110"]
  ],
  "0_14_1":[
    [0,"瑞昌","CN101240202"],[1,"庐山","CN101240203"],[2,"武宁","CN101240204"],[3,"德安","CN101240205"],[4,"永修","CN101240206"],[5,"湖口","CN101240207"],[6,"彭泽","CN101240208"],[7,"都昌","CN101240210"],[8,"浔阳","CN101240211"],[9,"修水","CN101240212"],[10,"共青城","CN101240213"],[11,"濂溪","CN101240214"],[12,"柴桑","CN101240215"]
  ],
  "0_14_2":[
    [0,"鄱阳","CN101240302"],[1,"婺源","CN101240303"],[2,"信州","CN101240304"],[3,"余干","CN101240305"],[4,"万年","CN101240306"],[5,"德兴","CN101240307"],[6,"广信","CN101240308"],[7,"弋阳","CN101240309"],[8,"横峰","CN101240310"],[9,"铅山","CN101240311"],[10,"玉山","CN101240312"],[11,"广丰","CN101240313"]
  ],
  "0_14_3":[
    [0,"广昌","CN101240402"],[1,"乐安","CN101240403"],[2,"崇仁","CN101240404"],[3,"金溪","CN101240405"],[4,"资溪","CN101240406"],[5,"宜黄","CN101240407"],[6,"南城","CN101240408"],[7,"南丰","CN101240409"],[8,"黎川","CN101240410"],[9,"东乡","CN101240411"],[10,"临川","CN101240412"]
  ],
  "0_14_4":[
    [0,"铜鼓","CN101240502"],[1,"宜丰","CN101240503"],[2,"万载","CN101240504"],[3,"上高","CN101240505"],[4,"靖安","CN101240506"],[5,"奉新","CN101240507"],[6,"高安","CN101240508"],[7,"樟树","CN101240509"],[8,"丰城","CN101240510"],[9,"袁州","CN101240511"]
  ],
  "0_14_5":[
    [0,"吉安县","CN101240602"],[1,"吉水","CN101240603"],[2,"新干","CN101240604"],[3,"峡江","CN101240605"],[4,"永丰","CN101240606"],[5,"永新","CN101240607"],[6,"井冈山","CN101240608"],[7,"万安","CN101240609"],[8,"遂川","CN101240610"],[9,"泰和","CN101240611"],[10,"安福","CN101240612"],[11,"吉州","CN101240614"],[12,"青原","CN101240615"]
  ],
  "0_14_6":[
    [0,"崇义","CN101240702"],[1,"上犹","CN101240703"],[2,"南康","CN101240704"],[3,"大余","CN101240705"],[4,"信丰","CN101240706"],[5,"宁都","CN101240707"],[6,"石城","CN101240708"],[7,"瑞金","CN101240709"],[8,"于都","CN101240710"],[9,"会昌","CN101240711"],[10,"安远","CN101240712"],[11,"全南","CN101240713"],[12,"龙南","CN101240714"],[13,"定南","CN101240715"],[14,"寻乌","CN101240716"],[15,"兴国","CN101240717"],[16,"赣县","CN101240718"],[17,"章贡","CN101240719"]
  ],
  "0_14_7":[
    [0,"乐平","CN101240802"],[1,"浮梁","CN101240803"],[2,"昌江","CN101240804"],[3,"珠山","CN101240805"]
  ],
  "0_14_8":[
    [0,"莲花","CN101240902"],[1,"上栗","CN101240903"],[2,"安源","CN101240904"],[3,"芦溪","CN101240905"],[4,"湘东","CN101240906"]
  ],
  "0_14_9":[
    [0,"分宜","CN101241002"],[1,"渝水","CN101241003"]
  ],
  "0_14_10":[
    [0,"余江","CN101241102"],[1,"贵溪","CN101241103"],[2,"月湖","CN101241104"]
  ],
  "0_15":[
    [0,"济南市","CN101120101"],[1,"青岛市","CN101120201"],[2,"淄博市","CN101120301"],[3,"德州市","CN101120401"],[4,"烟台市","CN101120501"],[5,"潍坊市","CN101120601"],[6,"济宁市","CN101120701"],[7,"泰安市","CN101120801"],[8,"临沂市","CN101120901"],[9,"菏泽市","CN101121001"],[10,"滨州市","CN101121101"],[11,"东营市","CN101121201"],[12,"威海市","CN101121301"],[13,"枣庄市","CN101121401"],[14,"日照市","CN101121501"],[15,"莱芜市","CN101121601"],[16,"聊城市","CN101121701"]
  ],
  "0_15_0":[
    [0,"长清","CN101120102"],[1,"商河","CN101120103"],[2,"章丘","CN101120104"],[3,"平阴","CN101120105"],[4,"济阳","CN101120106"],[5,"历下","CN101120107"],[6,"市中","CN101120108"],[7,"槐荫","CN101120109"],[8,"天桥","CN101120110"],[9,"历城","CN101120111"]
  ],
  "0_15_1":[
    [0,"崂山","CN101120202"],[1,"市南","CN101120203"],[2,"即墨","CN101120204"],[3,"胶州","CN101120205"],[4,"黄岛","CN101120206"],[5,"莱西","CN101120207"],[6,"平度","CN101120208"],[7,"市北","CN101120209"],[8,"李沧","CN101120210"],[9,"城阳","CN101120211"]
  ],
  "0_15_2":[
    [0,"淄川","CN101120302"],[1,"博山","CN101120303"],[2,"高青","CN101120304"],[3,"周村","CN101120305"],[4,"沂源","CN101120306"],[5,"桓台","CN101120307"],[6,"临淄","CN101120308"],[7,"张店","CN101120309"]
  ],
  "0_15_3":[
    [0,"武城","CN101120402"],[1,"临邑","CN101120403"],[3,"齐河","CN101120405"],[4,"乐陵","CN101120406"],[5,"庆云","CN101120407"],[6,"平原","CN101120408"],[7,"宁津","CN101120409"],[8,"夏津","CN101120410"],[9,"禹城","CN101120411"],[10,"德城","CN101120412"],[11,"陵城","CN101120413"]
  ],
  "0_15_4":[
    [0,"莱州","CN101120502"],[2,"蓬莱","CN101120504"],[3,"龙口","CN101120505"],[4,"招远","CN101120506"],[5,"栖霞","CN101120507"],[6,"福山","CN101120508"],[7,"牟平","CN101120509"],[8,"莱阳","CN101120510"],[9,"海阳","CN101120511"],[10,"芝罘","CN101120512"],[11,"莱山","CN101120513"]
  ],
  "0_15_5":[
    [0,"青州","CN101120602"],[1,"寿光","CN101120603"],[2,"临朐","CN101120604"],[3,"昌乐","CN101120605"],[4,"昌邑","CN101120606"],[5,"安丘","CN101120607"],[6,"高密","CN101120608"],[7,"诸城","CN101120609"],[8,"潍城","CN101120610"],[9,"寒亭","CN101120611"],[10,"坊子","CN101120612"],[11,"奎文","CN101120613"]
  ],
  "0_15_6":[
    [0,"嘉祥","CN101120702"],[1,"微山","CN101120703"],[2,"鱼台","CN101120704"],[3,"兖州","CN101120705"],[4,"金乡","CN101120706"],[5,"汶上","CN101120707"],[6,"泗水","CN101120708"],[7,"梁山","CN101120709"],[8,"曲阜","CN101120710"],[9,"邹城","CN101120711"],[10,"任城","CN101120712"]
  ],
  "0_15_7":[
    [0,"新泰","CN101120802"],[1,"泰山","CN101120803"],[2,"肥城","CN101120804"],[3,"东平","CN101120805"],[4,"宁阳","CN101120806"],[5,"岱岳","CN101120807"]
  ],
  "0_15_8":[
    [0,"莒南","CN101120902"],[1,"沂南","CN101120903"],[2,"兰陵","CN101120904"],[3,"临沭","CN101120905"],[4,"郯城","CN101120906"],[5,"蒙阴","CN101120907"],[6,"平邑","CN101120908"],[7,"费县","CN101120909"],[8,"沂水","CN101120910"],[9,"兰山","CN101120911"],[10,"罗庄","CN101120912"],[11,"河东","CN101120913"]
  ],
  "0_15_9":[
    [0,"鄄城","CN101121002"],[1,"郓城","CN101121003"],[2,"东明","CN101121004"],[3,"定陶","CN101121005"],[4,"巨野","CN101121006"],[5,"曹县","CN101121007"],[6,"成武","CN101121008"],[7,"单县","CN101121009"],[8,"牡丹","CN101121010"]
  ],
  "0_15_10":[
    [0,"博兴","CN101121102"],[1,"无棣","CN101121103"],[2,"阳信","CN101121104"],[3,"惠民","CN101121105"],[4,"沾化","CN101121106"],[5,"邹平","CN101121107"],[6,"滨城","CN101121108"]
  ],
  "0_15_11":[
    [0,"河口","CN101121202"],[1,"垦利","CN101121203"],[2,"利津","CN101121204"],[3,"广饶","CN101121205"],[4,"东营区","CN101121206"]
  ],
  "0_15_12":[
    [0,"文登","CN101121302"],[1,"荣成","CN101121303"],[2,"乳山","CN101121304"],[5,"环翠","CN101121307"]
  ],
  "0_15_13":[
    [0,"薛城","CN101121402"],[1,"峄城","CN101121403"],[2,"台儿庄","CN101121404"],[3,"滕州","CN101121405"],[4,"市中","CN101121406"],[5,"山亭","CN101121407"]
  ],
  "0_15_14":[
    [0,"五莲","CN101121502"],[1,"莒县","CN101121503"],[2,"东港","CN101121504"],[3,"岚山","CN101121505"]
  ],
  "0_15_15":[
    [1,"钢城","CN101121603"]
  ],
  "0_15_16":[
    [0,"冠县","CN101121702"],[1,"阳谷","CN101121703"],[2,"高唐","CN101121704"],[3,"茌平","CN101121705"],[4,"东阿","CN101121706"],[5,"临清","CN101121707"],[6,"东昌府","CN101121708"],[7,"莘县","CN101121709"]
  ],
  "0_16":[
    [0,"郑州市","CN101180101"],[1,"安阳市","CN101180201"],[2,"新乡市","CN101180301"],[3,"许昌市","CN101180401"],[4,"平顶山市","CN101180501"],[5,"信阳市","CN101180601"],[6,"南阳市","CN101180701"],[7,"开封市","CN101180801"],[8,"洛阳市","CN101180901"],[9,"商丘市","CN101181001"],[10,"焦作市","CN101181101"],[11,"鹤壁市","CN101181201"],[12,"濮阳市","CN101181301"],[13,"周口市","CN101181401"],[14,"漯河市","CN101181501"],[15,"驻马店市","CN101181601"],[16,"三门峡市","CN101181701"],[17,"济源市","CN101181801"]
  ],
  "0_16_0":[
    [0,"巩义","CN101180102"],[1,"荥阳","CN101180103"],[2,"登封","CN101180104"],[3,"新密","CN101180105"],[4,"新郑","CN101180106"],[5,"中牟","CN101180107"],[6,"上街","CN101180108"],[7,"中原","CN101180109"],[8,"二七","CN101180110"],[9,"管城","CN101180111"],[10,"金水","CN101180112"],[11,"惠济","CN101180113"]
  ],
  "0_16_1":[
    [0,"汤阴","CN101180202"],[1,"滑县","CN101180203"],[2,"内黄","CN101180204"],[3,"林州","CN101180205"],[4,"文峰","CN101180206"],[5,"北关","CN101180207"],[6,"殷都","CN101180208"],[7,"龙安","CN101180209"],[8,"安阳县","CN101180210"]
  ],
  "0_16_2":[
    [0,"获嘉","CN101180302"],[1,"原阳","CN101180303"],[2,"辉县","CN101180304"],[3,"卫辉","CN101180305"],[4,"延津","CN101180306"],[5,"封丘","CN101180307"],[6,"长垣","CN101180308"],[7,"红旗","CN101180309"],[8,"卫滨","CN101180310"],[9,"凤泉","CN101180311"],[10,"牧野","CN101180312"],[11,"新乡县","CN101180313"]
  ],
  "0_16_3":[
    [0,"鄢陵","CN101180402"],[1,"襄城","CN101180403"],[2,"长葛","CN101180404"],[3,"禹州","CN101180405"],[4,"魏都","CN101180406"],[5,"建安","CN101180407"]
  ],
  "0_16_4":[
    [0,"郏县","CN101180502"],[1,"宝丰","CN101180503"],[2,"汝州","CN101180504"],[3,"叶县","CN101180505"],[4,"舞钢","CN101180506"],[5,"鲁山","CN101180507"],[6,"石龙","CN101180508"],[7,"新华","CN101180509"],[8,"卫东","CN101180510"],[9,"湛河","CN101180511"]
  ],
  "0_16_5":[
    [0,"息县","CN101180602"],[1,"罗山","CN101180603"],[2,"光山","CN101180604"],[3,"新县","CN101180605"],[4,"淮滨","CN101180606"],[5,"潢川","CN101180607"],[6,"固始","CN101180608"],[7,"商城","CN101180609"],[8,"浉河","CN101180610"],[9,"平桥","CN101180611"]
  ],
  "0_16_6":[
    [0,"南召","CN101180702"],[1,"方城","CN101180703"],[2,"社旗","CN101180704"],[3,"西峡","CN101180705"],[4,"内乡","CN101180706"],[5,"镇平","CN101180707"],[6,"淅川","CN101180708"],[7,"新野","CN101180709"],[8,"唐河","CN101180710"],[9,"邓州","CN101180711"],[10,"桐柏","CN101180712"],[11,"宛城","CN101180713"],[12,"卧龙","CN101180714"]
  ],
  "0_16_7":[
    [0,"杞县","CN101180802"],[1,"尉氏","CN101180803"],[2,"通许","CN101180804"],[3,"兰考","CN101180805"],[4,"龙亭","CN101180806"],[5,"顺河","CN101180807"],[6,"鼓楼","CN101180808"],[7,"禹王台","CN101180809"],[8,"祥符","CN101180810"]
  ],
  "0_16_8":[
    [0,"新安","CN101180902"],[2,"宜阳","CN101180904"],[3,"洛宁","CN101180905"],[4,"伊川","CN101180906"],[5,"嵩县","CN101180907"],[6,"偃师","CN101180908"],[7,"栾川","CN101180909"],[8,"汝阳","CN101180910"],[9,"孟津","CN101180911"],[10,"老城","CN101180912"],[11,"西工","CN101180913"],[12,"瀍河","CN101180914"],[13,"涧西","CN101180915"],[14,"洛龙","CN101180916"]
  ],
  "0_16_9":[
    [0,"梁园","CN101181002"],[1,"睢县","CN101181003"],[2,"民权","CN101181004"],[3,"虞城","CN101181005"],[4,"柘城","CN101181006"],[5,"宁陵","CN101181007"],[6,"夏邑","CN101181008"],[7,"永城","CN101181009"],[8,"睢阳","CN101181010"]
  ],
  "0_16_10":[
    [0,"修武","CN101181102"],[1,"武陟","CN101181103"],[2,"沁阳","CN101181104"],[3,"解放","CN101181105"],[4,"博爱","CN101181106"],[5,"温县","CN101181107"],[6,"孟州","CN101181108"],[7,"中站","CN101181109"],[8,"马村","CN101181110"],[9,"山阳","CN101181111"]
  ],
  "0_16_11":[
    [0,"浚县","CN101181202"],[1,"淇县","CN101181203"],[2,"鹤山","CN101181204"],[3,"山城","CN101181205"],[4,"淇滨","CN101181206"]
  ],
  "0_16_12":[
    [0,"台前","CN101181302"],[1,"南乐","CN101181303"],[2,"清丰","CN101181304"],[3,"范县","CN101181305"],[4,"华龙","CN101181306"],[5,"濮阳县","CN101181307"]
  ],
  "0_16_13":[
    [0,"扶沟","CN101181402"],[1,"太康","CN101181403"],[2,"淮阳","CN101181404"],[3,"西华","CN101181405"],[4,"商水","CN101181406"],[5,"项城","CN101181407"],[6,"郸城","CN101181408"],[7,"鹿邑","CN101181409"],[8,"沈丘","CN101181410"],[9,"川汇","CN101181411"]
  ],
  "0_16_14":[
    [0,"临颍","CN101181502"],[1,"舞阳","CN101181503"],[2,"源汇","CN101181504"],[3,"郾城","CN101181505"],[4,"召陵","CN101181506"]
  ],
  "0_16_15":[
    [0,"西平","CN101181602"],[1,"遂平","CN101181603"],[2,"上蔡","CN101181604"],[3,"汝南","CN101181605"],[4,"泌阳","CN101181606"],[5,"平舆","CN101181607"],[6,"新蔡","CN101181608"],[7,"确山","CN101181609"],[8,"正阳","CN101181610"],[9,"驿城","CN101181611"]
  ],
  "0_16_16":[
    [0,"灵宝","CN101181702"],[1,"渑池","CN101181703"],[2,"卢氏","CN101181704"],[3,"义马","CN101181705"],[4,"湖滨","CN101181707"],[5,"陕州","CN101181708"]
  ],
  "0_17":[
    [0,"武汉市","CN101200101"],[1,"襄阳市","CN101200201"],[2,"鄂州市","CN101200301"],[3,"孝感市","CN101200401"],[4,"黄冈市","CN101200501"],[5,"黄石市","CN101200601"],[6,"咸宁市","CN101200701"],[7,"荆州市","CN101200801"],[8,"宜昌市","CN101200901"],[9,"恩施州","CN101201001"],[10,"十堰市","CN101201101"],[11,"神农架","CN101201201"],[12,"随州市","CN101201301"],[13,"荆门市","CN101201401"],[14,"天门市","CN101201501"],[15,"仙桃市","CN101201601"],[16,"潜江市","CN101201701"]
  ],
  "0_17_0":[
    [0,"蔡甸","CN101200102"],[1,"黄陂","CN101200103"],[2,"新洲","CN101200104"],[3,"江夏","CN101200105"],[4,"东西湖","CN101200106"],[5,"江岸","CN101200107"],[6,"江汉","CN101200108"],[7,"硚口","CN101200109"],[8,"汉阳","CN101200110"],[9,"武昌","CN101200111"],[10,"青山","CN101200112"],[11,"洪山","CN101200113"],[12,"汉南","CN101200114"]
  ],
  "0_17_1":[
    [0,"襄州","CN101200202"],[1,"保康","CN101200203"],[2,"南漳","CN101200204"],[3,"宜城","CN101200205"],[4,"老河口","CN101200206"],[5,"谷城","CN101200207"],[6,"枣阳","CN101200208"],[7,"襄城","CN101200209"],[8,"樊城","CN101200210"]
  ],
  "0_17_2":[
    [0,"梁子湖","CN101200302"],[1,"华容","CN101200303"],[2,"鄂城","CN101200304"]
  ],
  "0_17_3":[
    [0,"安陆","CN101200402"],[1,"云梦","CN101200403"],[2,"大悟","CN101200404"],[3,"应城","CN101200405"],[4,"汉川","CN101200406"],[5,"孝昌","CN101200407"],[6,"孝南","CN101200408"]
  ],
  "0_17_4":[
    [0,"红安","CN101200502"],[1,"麻城","CN101200503"],[2,"罗田","CN101200504"],[3,"英山","CN101200505"],[4,"浠水","CN101200506"],[5,"蕲春","CN101200507"],[6,"黄梅","CN101200508"],[7,"武穴","CN101200509"],[8,"团风","CN101200510"],[9,"黄州","CN101200511"]
  ],
  "0_17_5":[
    [0,"大冶","CN101200602"],[1,"阳新","CN101200603"],[2,"铁山","CN101200604"],[3,"下陆","CN101200605"],[4,"西塞山","CN101200606"],[5,"黄石港","CN101200607"]
  ],
  "0_17_6":[
    [0,"赤壁","CN101200702"],[1,"嘉鱼","CN101200703"],[2,"崇阳","CN101200704"],[3,"通城","CN101200705"],[4,"通山","CN101200706"],[5,"咸安","CN101200707"]
  ],
  "0_17_7":[
    [0,"江陵","CN101200802"],[1,"公安","CN101200803"],[2,"石首","CN101200804"],[3,"监利","CN101200805"],[4,"洪湖","CN101200806"],[5,"松滋","CN101200807"],[6,"沙市","CN101200808"],[7,"荆州区","CN101200809"]
  ],
  "0_17_8":[
    [0,"远安","CN101200902"],[1,"秭归","CN101200903"],[2,"兴山","CN101200904"],[3,"西陵","CN101200905"],[4,"五峰","CN101200906"],[5,"当阳","CN101200907"],[6,"长阳","CN101200908"],[7,"宜都","CN101200909"],[8,"枝江","CN101200910"],[10,"夷陵","CN101200912"],[11,"伍家岗","CN101200913"],[12,"点军","CN101200914"],[13,"猇亭","CN101200915"]
  ],
  "0_17_9":[
    [0,"利川","CN101201002"],[1,"建始","CN101201003"],[2,"咸丰","CN101201004"],[3,"宣恩","CN101201005"],[4,"鹤峰","CN101201006"],[5,"来凤","CN101201007"],[6,"巴东","CN101201008"],[7,"恩施","CN101201009"]
  ],
  "0_17_10":[
    [0,"竹溪","CN101201102"],[1,"郧西","CN101201103"],[2,"郧阳","CN101201104"],[3,"竹山","CN101201105"],[4,"房县","CN101201106"],[5,"丹江口","CN101201107"],[6,"茅箭","CN101201108"],[7,"张湾","CN101201109"]
  ],
  "0_17_12":[
    [0,"广水","CN101201302"],[1,"曾都","CN101201303"],[2,"随县","CN101201304"]
  ],
  "0_17_13":[
    [0,"钟祥","CN101201402"],[1,"京山","CN101201403"],[2,"掇刀","CN101201404"],[3,"沙洋","CN101201405"],[4,"东宝","CN101201406"]
  ],
  "0_18":[
    [0,"长沙市","CN101250101"],[1,"湘潭市","CN101250201"],[2,"株洲市","CN101250301"],[3,"衡阳市","CN101250401"],[4,"郴州市","CN101250501"],[5,"常德市","CN101250601"],[6,"益阳市","CN101250700"],[7,"娄底市","CN101250801"],[8,"邵阳市","CN101250901"],[9,"岳阳市","CN101251001"],[10,"张家界市","CN101251101"],[11,"怀化市","CN101251201"],[12,"永州市","CN101251401"],[13,"湘西州","CN101251509"]
  ],
  "0_18_0":[
    [0,"宁乡","CN101250102"],[1,"浏阳","CN101250103"],[3,"望城","CN101250105"],[4,"长沙县","CN101250106"],[5,"芙蓉","CN101250107"],[6,"天心","CN101250108"],[7,"岳麓","CN101250109"],[8,"开福","CN101250110"],[9,"雨花","CN101250111"]
  ],
  "0_18_1":[
    [0,"韶山","CN101250202"],[1,"湘乡","CN101250203"],[2,"雨湖","CN101250204"],[3,"岳塘","CN101250205"],[4,"湘潭县","CN101250206"]
  ],
  "0_18_2":[
    [0,"攸县","CN101250302"],[1,"醴陵","CN101250303"],[2,"荷塘","CN101250304"],[3,"茶陵","CN101250305"],[4,"炎陵","CN101250306"],[5,"芦淞","CN101250307"],[6,"石峰","CN101250308"],[7,"天元","CN101250309"],[8,"渌口","CN101250310"]
  ],
  "0_18_3":[
    [0,"衡山","CN101250402"],[1,"衡东","CN101250403"],[2,"祁东","CN101250404"],[3,"衡阳县","CN101250405"],[4,"常宁","CN101250406"],[5,"衡南","CN101250407"],[6,"耒阳","CN101250408"],[7,"南岳","CN101250409"],[8,"珠晖","CN101250410"],[9,"雁峰","CN101250411"],[10,"石鼓","CN101250412"],[11,"蒸湘","CN101250413"]
  ],
  "0_18_4":[
    [0,"桂阳","CN101250502"],[1,"嘉禾","CN101250503"],[2,"宜章","CN101250504"],[3,"临武","CN101250505"],[4,"北湖","CN101250506"],[5,"资兴","CN101250507"],[6,"汝城","CN101250508"],[7,"安仁","CN101250509"],[8,"永兴","CN101250510"],[9,"桂东","CN101250511"],[10,"苏仙","CN101250512"]
  ],
  "0_18_5":[
    [0,"安乡","CN101250602"],[1,"桃源","CN101250603"],[2,"汉寿","CN101250604"],[3,"澧县","CN101250605"],[4,"临澧","CN101250606"],[5,"石门","CN101250607"],[6,"津市","CN101250608"],[7,"武陵","CN101250609"],[8,"鼎城","CN101250610"]
  ],
  "0_18_6":[
    [0,"赫山区","CN101250701"],[1,"南县","CN101250702"],[2,"桃江","CN101250703"],[3,"安化","CN101250704"],[4,"沅江","CN101250705"],[5,"资阳","CN101250706"]
  ],
  "0_18_7":[
    [0,"双峰","CN101250802"],[1,"冷水江","CN101250803"],[2,"娄星","CN101250804"],[3,"新化","CN101250805"],[4,"涟源","CN101250806"]
  ],
  "0_18_8":[
    [0,"隆回","CN101250902"],[1,"洞口","CN101250903"],[2,"新邵","CN101250904"],[3,"邵东","CN101250905"],[4,"绥宁","CN101250906"],[5,"新宁","CN101250907"],[6,"武冈","CN101250908"],[7,"城步","CN101250909"],[8,"邵阳县","CN101250910"],[9,"双清","CN101250911"],[10,"大祥","CN101250912"],[11,"北塔","CN101250913"]
  ],
  "0_18_9":[
    [0,"华容","CN101251002"],[1,"湘阴","CN101251003"],[2,"汨罗","CN101251004"],[3,"平江","CN101251005"],[4,"临湘","CN101251006"],[5,"岳阳楼区","CN101251007"],[6,"云溪","CN101251008"],[7,"君山","CN101251009"],[8,"岳阳县","CN101251010"]
  ],
  "0_18_10":[
    [0,"桑植","CN101251102"],[1,"慈利","CN101251103"],[2,"武陵源","CN101251104"],[3,"永定","CN101251105"]
  ],
  "0_18_11":[
    [0,"鹤城","CN101251202"],[1,"沅陵","CN101251203"],[2,"辰溪","CN101251204"],[3,"靖州","CN101251205"],[4,"会同","CN101251206"],[5,"通道","CN101251207"],[6,"麻阳","CN101251208"],[7,"新晃","CN101251209"],[8,"芷江","CN101251210"],[9,"溆浦","CN101251211"],[10,"中方","CN101251212"],[11,"洪江","CN101251213"]
  ],
  "0_18_12":[
    [0,"祁阳","CN101251402"],[1,"东安","CN101251403"],[2,"双牌","CN101251404"],[3,"道县","CN101251405"],[4,"宁远","CN101251406"],[5,"江永","CN101251407"],[6,"蓝山","CN101251408"],[7,"新田","CN101251409"],[8,"江华","CN101251410"],[9,"冷水滩","CN101251411"],[10,"零陵","CN101251412"]
  ],
  "0_18_13":[
    [0,"吉首","CN101251501"],[1,"保靖","CN101251502"],[2,"永顺","CN101251503"],[3,"古丈","CN101251504"],[4,"凤凰","CN101251505"],[5,"泸溪","CN101251506"],[6,"龙山","CN101251507"],[7,"花垣","CN101251508"]
  ],
  "0_19":[
    [0,"广州市","CN101280101"],[1,"韶关市","CN101280201"],[2,"惠州市","CN101280301"],[3,"梅州市","CN101280401"],[4,"汕头市","CN101280501"],[5,"深圳市","CN101280601"],[6,"珠海市","CN101280701"],[7,"佛山市","CN101280800"],[8,"肇庆市","CN101280901"],[9,"湛江市","CN101281001"],[10,"江门市","CN101281101"],[11,"河源市","CN101281201"],[12,"清远市","CN101281301"],[13,"云浮市","CN101281401"],[14,"潮州市","CN101281501"],[15,"东莞市","CN101281601"],[16,"中山市","CN101281701"],[17,"阳江市","CN101281801"],[18,"揭阳市","CN101281901"],[19,"茂名市","CN101282001"],[20,"汕尾市","CN101282101"]
  ],
  "0_19_0":[
    [0,"番禺","CN101280102"],[1,"从化","CN101280103"],[2,"增城","CN101280104"],[3,"花都","CN101280105"],[4,"荔湾","CN101280106"],[5,"越秀","CN101280107"],[6,"海珠","CN101280108"],[7,"天河","CN101280109"],[8,"白云","CN101280110"],[9,"黄埔","CN101280111"],[10,"南沙","CN101280112"]
  ],
  "0_19_1":[
    [0,"乳源","CN101280202"],[1,"始兴","CN101280203"],[2,"翁源","CN101280204"],[3,"乐昌","CN101280205"],[4,"仁化","CN101280206"],[5,"南雄","CN101280207"],[6,"新丰","CN101280208"],[7,"曲江","CN101280209"],[8,"浈江","CN101280210"],[9,"武江","CN101280211"]
  ],
  "0_19_2":[
    [0,"博罗","CN101280302"],[1,"惠阳","CN101280303"],[2,"惠东","CN101280304"],[3,"龙门","CN101280305"],[4,"惠城","CN101280306"]
  ],
  "0_19_3":[
    [0,"兴宁","CN101280402"],[1,"蕉岭","CN101280403"],[2,"大埔","CN101280404"],[3,"梅江","CN101280405"],[4,"丰顺","CN101280406"],[5,"平远","CN101280407"],[6,"五华","CN101280408"],[7,"梅县","CN101280409"]
  ],
  "0_19_4":[
    [0,"潮阳","CN101280502"],[1,"澄海","CN101280503"],[2,"南澳","CN101280504"],[3,"龙湖","CN101280505"],[4,"金平","CN101280506"],[5,"濠江","CN101280507"],[6,"潮南","CN101280508"]
  ],
  "0_19_5":[
    [0,"罗湖","CN101280602"],[1,"福田","CN101280603"],[2,"南山","CN101280604"],[3,"宝安","CN101280605"],[4,"龙岗","CN101280606"],[5,"盐田","CN101280607"],[6,"龙华","CN101280608"],[7,"坪山","CN101280609"],[8,"光明","CN101280610"]
  ],
  "0_19_6":[
    [0,"斗门","CN101280702"],[1,"金湾","CN101280703"],[2,"香洲","CN101280704"]
  ],
  "0_19_7":[
    [0,"顺德","CN101280801"],[1,"三水","CN101280802"],[2,"南海","CN101280803"],[3,"高明","CN101280804"],[4,"禅城","CN101280805"]
  ],
  "0_19_8":[
    [0,"广宁","CN101280902"],[1,"四会","CN101280903"],[2,"端州","CN101280904"],[3,"德庆","CN101280905"],[4,"怀集","CN101280906"],[5,"封开","CN101280907"],[6,"高要","CN101280908"],[7,"鼎湖","CN101280909"]
  ],
  "0_19_9":[
    [0,"吴川","CN101281002"],[1,"雷州","CN101281003"],[2,"徐闻","CN101281004"],[3,"廉江","CN101281005"],[4,"赤坎","CN101281006"],[5,"遂溪","CN101281007"],[6,"坡头","CN101281008"],[7,"霞山","CN101281009"],[8,"麻章","CN101281010"]
  ],
  "0_19_10":[
    [0,"开平","CN101281103"],[1,"新会","CN101281104"],[2,"恩平","CN101281105"],[3,"台山","CN101281106"],[4,"蓬江","CN101281107"],[5,"鹤山","CN101281108"],[6,"江海","CN101281109"]
  ],
  "0_19_11":[
    [0,"紫金","CN101281202"],[1,"连平","CN101281203"],[2,"和平","CN101281204"],[3,"龙川","CN101281205"],[4,"东源","CN101281206"],[5,"源城","CN101281207"]
  ],
  "0_19_12":[
    [0,"连南","CN101281302"],[1,"连州","CN101281303"],[2,"连山","CN101281304"],[3,"阳山","CN101281305"],[4,"佛冈","CN101281306"],[5,"英德","CN101281307"],[6,"清新","CN101281308"],[7,"清城","CN101281309"]
  ],
  "0_19_13":[
    [0,"罗定","CN101281402"],[1,"新兴","CN101281403"],[2,"郁南","CN101281404"],[3,"云城","CN101281405"],[4,"云安","CN101281406"]
  ],
  "0_19_14":[
    [0,"饶平","CN101281502"],[1,"潮安","CN101281503"],[2,"湘桥","CN101281504"]
  ],
  "0_19_17":[
    [0,"阳春","CN101281802"],[1,"阳东","CN101281803"],[2,"阳西","CN101281804"],[3,"江城","CN101281805"]
  ],
  "0_19_18":[
    [0,"揭西","CN101281902"],[1,"普宁","CN101281903"],[2,"惠来","CN101281904"],[3,"揭东","CN101281905"],[4,"榕城","CN101281906"]
  ],
  "0_19_19":[
    [0,"高州","CN101282002"],[1,"化州","CN101282003"],[2,"电白","CN101282004"],[3,"信宜","CN101282005"],[4,"茂南","CN101282007"]
  ],
  "0_19_20":[
    [0,"海丰","CN101282102"],[1,"陆丰","CN101282103"],[2,"陆河","CN101282104"],[3,"城区","CN101282105"]
  ],
  "0_20":[
    [0,"南宁市","CN101300101"],[1,"崇左市","CN101300201"],[2,"柳州市","CN101300301"],[3,"来宾市","CN101300401"],[4,"桂林市","CN101300501"],[5,"梧州市","CN101300601"],[6,"贺州市","CN101300701"],[7,"贵港市","CN101300801"],[8,"玉林市","CN101300901"],[9,"百色市","CN101301001"],[10,"钦州市","CN101301101"],[11,"河池市","CN101301201"],[12,"北海市","CN101301301"],[13,"防城港市","CN101301401"]
  ],
  "0_20_0":[
    [0,"兴宁","CN101300102"],[1,"邕宁","CN101300103"],[2,"横县","CN101300104"],[3,"隆安","CN101300105"],[4,"马山","CN101300106"],[5,"上林","CN101300107"],[6,"武鸣","CN101300108"],[7,"宾阳","CN101300109"],[8,"青秀","CN101300110"],[9,"江南","CN101300111"],[10,"西乡塘","CN101300112"],[11,"良庆","CN101300113"]
  ],
  "0_20_1":[
    [0,"天等","CN101300202"],[1,"龙州","CN101300203"],[2,"凭祥","CN101300204"],[3,"大新","CN101300205"],[4,"扶绥","CN101300206"],[5,"宁明","CN101300207"],[6,"江州","CN101300208"]
  ],
  "0_20_2":[
    [0,"柳城","CN101300302"],[1,"城中","CN101300303"],[2,"鹿寨","CN101300304"],[3,"柳江","CN101300305"],[4,"融安","CN101300306"],[5,"融水","CN101300307"],[6,"三江","CN101300308"],[7,"鱼峰","CN101300309"],[8,"柳南","CN101300310"],[9,"柳北","CN101300311"]
  ],
  "0_20_3":[
    [0,"忻城","CN101300402"],[1,"金秀","CN101300403"],[2,"象州","CN101300404"],[3,"武宣","CN101300405"],[4,"合山","CN101300406"],[5,"兴宾","CN101300407"]
  ],
  "0_20_4":[
    [0,"秀峰","CN101300502"],[1,"龙胜","CN101300503"],[2,"永福","CN101300504"],[3,"临桂","CN101300505"],[4,"兴安","CN101300506"],[5,"灵川","CN101300507"],[6,"全州","CN101300508"],[7,"灌阳","CN101300509"],[8,"阳朔","CN101300510"],[9,"恭城","CN101300511"],[10,"平乐","CN101300512"],[11,"荔浦","CN101300513"],[12,"资源","CN101300514"],[13,"叠彩","CN101300515"],[14,"象山","CN101300516"],[15,"七星","CN101300517"],[16,"雁山","CN101300518"]
  ],
  "0_20_5":[
    [0,"藤县","CN101300602"],[1,"万秀","CN101300603"],[2,"苍梧","CN101300604"],[3,"蒙山","CN101300605"],[4,"岑溪","CN101300606"],[5,"长洲","CN101300607"],[6,"龙圩","CN101300608"]
  ],
  "0_20_6":[
    [0,"昭平","CN101300702"],[1,"富川","CN101300703"],[2,"钟山","CN101300704"],[3,"八步","CN101300705"],[4,"平桂","CN101300706"]
  ],
  "0_20_7":[
    [0,"桂平","CN101300802"],[1,"平南","CN101300803"],[2,"港北","CN101300804"],[3,"港南","CN101300805"],[4,"覃塘","CN101300806"]
  ],
  "0_20_8":[
    [0,"博白","CN101300902"],[1,"北流","CN101300903"],[2,"容县","CN101300904"],[3,"陆川","CN101300905"],[4,"兴业","CN101300906"],[5,"玉州","CN101300907"],[6,"福绵","CN101300908"]
  ],
  "0_20_9":[
    [0,"那坡","CN101301002"],[1,"田阳","CN101301003"],[2,"德保","CN101301004"],[3,"靖西","CN101301005"],[4,"田东","CN101301006"],[5,"平果","CN101301007"],[6,"隆林","CN101301008"],[7,"西林","CN101301009"],[8,"乐业","CN101301010"],[9,"凌云","CN101301011"],[10,"田林","CN101301012"],[11,"右江","CN101301013"]
  ],
  "0_20_10":[
    [0,"浦北","CN101301102"],[1,"灵山","CN101301103"],[2,"钦南","CN101301104"],[3,"钦北","CN101301105"]
  ],
  "0_20_11":[
    [0,"天峨","CN101301202"],[1,"东兰","CN101301203"],[2,"巴马","CN101301204"],[3,"环江","CN101301205"],[4,"罗城","CN101301206"],[5,"宜州","CN101301207"],[6,"凤山","CN101301208"],[7,"南丹","CN101301209"],[8,"都安","CN101301210"],[9,"大化","CN101301211"],[10,"金城江","CN101301212"]
  ],
  "0_20_12":[
    [0,"合浦","CN101301302"],[2,"海城","CN101301304"],[3,"银海","CN101301305"],[4,"铁山港","CN101301306"]
  ],
  "0_20_13":[
    [0,"上思","CN101301402"],[1,"东兴","CN101301403"],[2,"港口","CN101301404"],[3,"防城","CN101301405"]
  ],
  "0_21":[
    [0,"海口市","CN101310101"],[1,"三亚市","CN101310201"],[2,"东方市","CN101310202"],[3,"临高县","CN101310203"],[4,"澄迈县","CN101310204"],[5,"儋州市","CN101310205"],[6,"昌江县","CN101310206"],[7,"白沙县","CN101310207"],[8,"琼中县","CN101310208"],[9,"定安县","CN101310209"],[10,"屯昌县","CN101310210"],[11,"琼海市","CN101310211"],[12,"文昌市","CN101310212"],[13,"保亭县","CN101310214"],[14,"万宁市","CN101310215"],[15,"陵水县","CN101310216"],[16,"乐东县","CN101310221"],[17,"五指山市","CN101310222"],[18,"三沙市","CN101310301"]
  ],
  "0_21_0":[
    [0,"秀英","CN101310102"],[1,"龙华","CN101310103"],[2,"琼山","CN101310104"],[3,"美兰","CN101310105"]
  ],
  "0_21_1":[
    [0,"海棠","CN101310213"],[1,"吉阳","CN101310218"],[2,"天涯","CN101310219"],[3,"崖州","CN101310223"]
  ],
  "0_21_18":[
    [0,"西沙","CN101310302"],[2,"南沙","CN101310304"]
  ],
  "0_22":[
    [0,"成都市","CN101270101"],[1,"攀枝花市","CN101270201"],[2,"自贡市","CN101270301"],[3,"绵阳市","CN101270401"],[4,"南充市","CN101270501"],[5,"达州市","CN101270601"],[6,"遂宁市","CN101270701"],[7,"广安市","CN101270801"],[8,"巴中市","CN101270901"],[9,"泸州市","CN101271001"],[10,"宜宾市","CN101271101"],[11,"内江市","CN101271201"],[12,"资阳市","CN101271301"],[13,"乐山市","CN101271401"],[14,"眉山市","CN101271501"],[15,"凉山州","CN101271601"],[16,"雅安市","CN101271701"],[17,"甘孜州","CN101271801"],[18,"阿坝州","CN101271901"],[19,"德阳市","CN101272001"],[20,"广元市","CN101272101"]
  ],
  "0_22_0":[
    [0,"龙泉驿","CN101270102"],[1,"新都","CN101270103"],[2,"温江","CN101270104"],[3,"金堂","CN101270105"],[4,"双流","CN101270106"],[5,"郫都","CN101270107"],[6,"大邑","CN101270108"],[7,"蒲江","CN101270109"],[8,"新津","CN101270110"],[9,"都江堰","CN101270111"],[10,"彭州","CN101270112"],[11,"邛崃","CN101270113"],[12,"崇州","CN101270114"],[13,"青白江","CN101270115"],[14,"锦江","CN101270116"],[15,"青羊","CN101270117"],[16,"金牛","CN101270118"],[17,"武侯","CN101270119"],[18,"成华","CN101270120"],[19,"简阳","CN101270121"]
  ],
  "0_22_1":[
    [0,"仁和","CN101270202"],[1,"米易","CN101270203"],[2,"盐边","CN101270204"],[3,"东区","CN101270205"],[4,"西区","CN101270206"]
  ],
  "0_22_2":[
    [0,"富顺","CN101270302"],[1,"荣县","CN101270303"],[2,"自流井","CN101270304"],[3,"贡井","CN101270305"],[4,"大安","CN101270306"],[5,"沿滩","CN101270307"]
  ],
  "0_22_3":[
    [0,"三台","CN101270402"],[1,"盐亭","CN101270403"],[2,"梓潼","CN101270405"],[3,"北川","CN101270406"],[4,"平武","CN101270407"],[5,"江油","CN101270408"],[6,"涪城","CN101270409"],[7,"游仙","CN101270410"],[8,"安州","CN101270411"]
  ],
  "0_22_4":[
    [0,"南部","CN101270502"],[1,"营山","CN101270503"],[2,"蓬安","CN101270504"],[3,"仪陇","CN101270505"],[4,"西充","CN101270506"],[5,"阆中","CN101270507"],[6,"顺庆","CN101270508"],[7,"高坪","CN101270509"],[8,"嘉陵","CN101270510"]
  ],
  "0_22_5":[
    [0,"宣汉","CN101270602"],[1,"开江","CN101270603"],[2,"大竹","CN101270604"],[3,"渠县","CN101270605"],[4,"万源","CN101270606"],[5,"通川","CN101270607"],[6,"达川","CN101270608"]
  ],
  "0_22_6":[
    [0,"蓬溪","CN101270702"],[1,"射洪","CN101270703"],[2,"船山","CN101270704"],[3,"安居","CN101270705"],[4,"大英","CN101270706"]
  ],
  "0_22_7":[
    [0,"岳池","CN101270802"],[1,"武胜","CN101270803"],[2,"邻水","CN101270804"],[3,"华蓥","CN101270805"],[4,"前锋","CN101270806"],[5,"广安区","CN101270807"]
  ],
  "0_22_8":[
    [0,"通江","CN101270902"],[1,"南江","CN101270903"],[2,"平昌","CN101270904"],[3,"巴州","CN101270905"],[4,"恩阳","CN101270906"]
  ],
  "0_22_9":[
    [0,"江阳","CN101271002"],[1,"泸县","CN101271003"],[2,"合江","CN101271004"],[3,"叙永","CN101271005"],[4,"古蔺","CN101271006"],[5,"纳溪","CN101271007"],[6,"龙马潭","CN101271008"]
  ],
  "0_22_10":[
    [0,"翠屏","CN101271102"],[1,"叙州区","CN101271103"],[2,"南溪","CN101271104"],[3,"江安","CN101271105"],[4,"长宁","CN101271106"],[5,"高县","CN101271107"],[6,"珙县","CN101271108"],[7,"筠连","CN101271109"],[8,"兴文","CN101271110"],[9,"屏山","CN101271111"]
  ],
  "0_22_11":[
    [0,"东兴","CN101271202"],[1,"威远","CN101271203"],[2,"资中","CN101271204"],[3,"隆昌","CN101271205"],[4,"市中","CN101271206"]
  ],
  "0_22_12":[
    [0,"安岳","CN101271302"],[1,"乐至","CN101271303"],[2,"雁江","CN101271305"]
  ],
  "0_22_13":[
    [0,"犍为","CN101271402"],[1,"井研","CN101271403"],[2,"夹江","CN101271404"],[3,"沐川","CN101271405"],[4,"峨边","CN101271406"],[5,"马边","CN101271407"],[7,"市中","CN101271410"],[8,"沙湾","CN101271411"],[9,"五通桥","CN101271412"],[10,"金口河","CN101271413"],[11,"峨眉山市","CN101271414"]
  ],
  "0_22_14":[
    [0,"仁寿","CN101271502"],[1,"彭山","CN101271503"],[2,"洪雅","CN101271504"],[3,"丹棱","CN101271505"],[4,"青神","CN101271506"],[5,"东坡","CN101271507"]
  ],
  "0_22_15":[
    [0,"木里","CN101271603"],[1,"盐源","CN101271604"],[2,"德昌","CN101271605"],[3,"会理","CN101271606"],[4,"会东","CN101271607"],[5,"宁南","CN101271608"],[6,"普格","CN101271609"],[7,"西昌","CN101271610"],[8,"金阳","CN101271611"],[9,"昭觉","CN101271612"],[10,"喜德","CN101271613"],[11,"冕宁","CN101271614"],[12,"越西","CN101271615"],[13,"甘洛","CN101271616"],[14,"雷波","CN101271617"],[15,"美姑","CN101271618"],[16,"布拖","CN101271619"]
  ],
  "0_22_16":[
    [0,"名山","CN101271702"],[1,"荥经","CN101271703"],[2,"汉源","CN101271704"],[3,"石棉","CN101271705"],[4,"天全","CN101271706"],[5,"芦山","CN101271707"],[6,"宝兴","CN101271708"],[7,"雨城","CN101271709"]
  ],
  "0_22_17":[
    [0,"康定","CN101271802"],[1,"泸定","CN101271803"],[2,"丹巴","CN101271804"],[3,"九龙","CN101271805"],[4,"雅江","CN101271806"],[5,"道孚","CN101271807"],[6,"炉霍","CN101271808"],[7,"新龙","CN101271809"],[8,"德格","CN101271810"],[9,"白玉","CN101271811"],[10,"石渠","CN101271812"],[11,"色达","CN101271813"],[12,"理塘","CN101271814"],[13,"巴塘","CN101271815"],[14,"乡城","CN101271816"],[15,"稻城","CN101271817"],[16,"得荣","CN101271818"],[17,"甘孜县","CN101271819"]
  ],
  "0_22_18":[
    [0,"汶川","CN101271902"],[1,"理县","CN101271903"],[2,"茂县","CN101271904"],[3,"松潘","CN101271905"],[4,"九寨沟","CN101271906"],[5,"金川","CN101271907"],[6,"小金","CN101271908"],[7,"黑水","CN101271909"],[8,"马尔康","CN101271910"],[9,"壤塘","CN101271911"],[10,"若尔盖","CN101271912"],[11,"红原","CN101271913"],[12,"阿坝县","CN101271914"]
  ],
  "0_22_19":[
    [0,"中江","CN101272002"],[1,"广汉","CN101272003"],[2,"什邡","CN101272004"],[3,"绵竹","CN101272005"],[4,"罗江","CN101272006"],[5,"旌阳","CN101272007"]
  ],
  "0_22_20":[
    [0,"旺苍","CN101272102"],[1,"青川","CN101272103"],[2,"剑阁","CN101272104"],[3,"苍溪","CN101272105"],[4,"利州","CN101272106"],[5,"昭化","CN101272107"],[6,"朝天","CN101272108"]
  ],
  "0_23":[
    [0,"贵阳市","CN101260101"],[1,"遵义市","CN101260201"],[2,"安顺市","CN101260301"],[3,"黔南州","CN101260413"],[4,"黔东南州","CN101260506"],[5,"铜仁市","CN101260601"],[6,"毕节市","CN101260701"],[7,"六盘水市","CN101260803"],[8,"黔西南州","CN101260906"]
  ],
  "0_23_0":[
    [0,"白云","CN101260102"],[1,"花溪","CN101260103"],[2,"乌当","CN101260104"],[3,"息烽","CN101260105"],[4,"开阳","CN101260106"],[5,"修文","CN101260107"],[6,"清镇","CN101260108"],[7,"云岩","CN101260110"],[8,"南明","CN101260111"],[9,"观山湖","CN101260112"]
  ],
  "0_23_1":[
    [0,"仁怀","CN101260203"],[1,"绥阳","CN101260204"],[2,"湄潭","CN101260205"],[3,"凤冈","CN101260206"],[4,"桐梓","CN101260207"],[5,"赤水","CN101260208"],[6,"习水","CN101260209"],[7,"道真","CN101260210"],[8,"正安","CN101260211"],[9,"务川","CN101260212"],[10,"余庆","CN101260213"],[11,"汇川","CN101260214"],[12,"红花岗","CN101260215"],[13,"播州","CN101260216"]
  ],
  "0_23_2":[
    [0,"普定","CN101260302"],[1,"镇宁","CN101260303"],[2,"平坝","CN101260304"],[3,"紫云","CN101260305"],[4,"关岭","CN101260306"],[5,"西秀","CN101260307"]
  ],
  "0_23_3":[
    [0,"都匀","CN101260401"],[1,"贵定","CN101260402"],[2,"瓮安","CN101260403"],[3,"长顺","CN101260404"],[4,"福泉","CN101260405"],[5,"惠水","CN101260406"],[6,"龙里","CN101260407"],[7,"罗甸","CN101260408"],[8,"平塘","CN101260409"],[9,"独山","CN101260410"],[10,"三都","CN101260411"],[11,"荔波","CN101260412"]
  ],
  "0_23_4":[
    [0,"凯里","CN101260501"],[1,"岑巩","CN101260502"],[2,"施秉","CN101260503"],[3,"镇远","CN101260504"],[4,"黄平","CN101260505"],[5,"麻江","CN101260507"],[6,"丹寨","CN101260508"],[7,"三穗","CN101260509"],[8,"台江","CN101260510"],[9,"剑河","CN101260511"],[10,"雷山","CN101260512"],[11,"黎平","CN101260513"],[12,"天柱","CN101260514"],[13,"锦屏","CN101260515"],[14,"榕江","CN101260516"],[15,"从江","CN101260517"]
  ],
  "0_23_5":[
    [0,"江口","CN101260602"],[1,"玉屏","CN101260603"],[2,"万山","CN101260604"],[3,"思南","CN101260605"],[4,"碧江","CN101260606"],[5,"印江","CN101260607"],[6,"石阡","CN101260608"],[7,"沿河","CN101260609"],[8,"德江","CN101260610"],[9,"松桃","CN101260611"]
  ],
  "0_23_6":[
    [0,"赫章","CN101260702"],[1,"金沙","CN101260703"],[2,"威宁","CN101260704"],[3,"大方","CN101260705"],[4,"纳雍","CN101260706"],[5,"织金","CN101260707"],[6,"黔西","CN101260708"],[7,"七星关","CN101260709"]
  ],
  "0_23_7":[
    [0,"水城","CN101260801"],[1,"六枝","CN101260802"],[2,"盘州","CN101260804"],[3,"钟山","CN101260805"]
  ],
  "0_23_8":[
    [0,"兴义","CN101260901"],[1,"晴隆","CN101260902"],[2,"兴仁","CN101260903"],[3,"贞丰","CN101260904"],[4,"望谟","CN101260905"],[5,"安龙","CN101260907"],[6,"册亨","CN101260908"],[7,"普安","CN101260909"]
  ],
  "0_24":[
    [0,"昆明市","CN101290101"],[1,"大理州","CN101290201"],[2,"红河州","CN101290301"],[3,"曲靖市","CN101290401"],[4,"保山市","CN101290501"],[5,"文山州","CN101290601"],[6,"玉溪市","CN101290701"],[7,"楚雄州","CN101290801"],[8,"普洱市","CN101290901"],[9,"昭通市","CN101291001"],[10,"临沧市","CN101291101"],[11,"怒江州","CN101291201"],[12,"迪庆州","CN101291305"],[13,"丽江市","CN101291401"],[14,"德宏州","CN101291501"],[15,"西双版纳州","CN101291602"]
  ],
  "0_24_0":[
    [0,"五华","CN101290102"],[1,"东川","CN101290103"],[2,"寻甸","CN101290104"],[3,"晋宁","CN101290105"],[4,"宜良","CN101290106"],[5,"石林","CN101290107"],[6,"呈贡","CN101290108"],[7,"富民","CN101290109"],[8,"嵩明","CN101290110"],[9,"禄劝","CN101290111"],[10,"安宁","CN101290112"],[12,"盘龙","CN101290114"],[13,"官渡","CN101290115"],[14,"西山","CN101290116"]
  ],
  "0_24_1":[
    [0,"云龙","CN101290202"],[1,"漾濞","CN101290203"],[2,"永平","CN101290204"],[3,"宾川","CN101290205"],[4,"弥渡","CN101290206"],[5,"祥云","CN101290207"],[6,"巍山","CN101290208"],[7,"剑川","CN101290209"],[8,"洱源","CN101290210"],[9,"鹤庆","CN101290211"],[10,"南涧","CN101290212"],[11,"大理","CN101290213"]
  ],
  "0_24_2":[
    [0,"石屏","CN101290302"],[1,"建水","CN101290303"],[2,"弥勒","CN101290304"],[3,"元阳","CN101290305"],[4,"绿春","CN101290306"],[5,"开远","CN101290307"],[6,"个旧","CN101290308"],[7,"蒙自","CN101290309"],[8,"屏边","CN101290310"],[9,"泸西","CN101290311"],[10,"金平","CN101290312"],[11,"河口","CN101290313"],[12,"红河县","CN101290314"]
  ],
  "0_24_3":[
    [0,"沾益","CN101290402"],[1,"陆良","CN101290403"],[2,"富源","CN101290404"],[3,"马龙","CN101290405"],[4,"师宗","CN101290406"],[5,"罗平","CN101290407"],[6,"会泽","CN101290408"],[7,"宣威","CN101290409"],[8,"麒麟","CN101290410"]
  ],
  "0_24_4":[
    [0,"隆阳","CN101290502"],[1,"龙陵","CN101290503"],[2,"施甸","CN101290504"],[3,"昌宁","CN101290505"],[4,"腾冲","CN101290506"]
  ],
  "0_24_5":[
    [0,"西畴","CN101290602"],[1,"马关","CN101290603"],[2,"麻栗坡","CN101290604"],[3,"砚山","CN101290605"],[4,"丘北","CN101290606"],[5,"广南","CN101290607"],[6,"富宁","CN101290608"],[7,"文山","CN101290609"]
  ],
  "0_24_6":[
    [0,"澄江","CN101290702"],[1,"江川","CN101290703"],[2,"通海","CN101290704"],[3,"华宁","CN101290705"],[4,"新平","CN101290706"],[5,"易门","CN101290707"],[6,"峨山","CN101290708"],[7,"元江","CN101290709"],[8,"红塔","CN101290710"]
  ],
  "0_24_7":[
    [0,"大姚","CN101290802"],[1,"元谋","CN101290803"],[2,"姚安","CN101290804"],[3,"牟定","CN101290805"],[4,"南华","CN101290806"],[5,"武定","CN101290807"],[6,"禄丰","CN101290808"],[7,"双柏","CN101290809"],[8,"永仁","CN101290810"],[9,"楚雄","CN101290811"]
  ],
  "0_24_8":[
    [0,"景谷","CN101290902"],[1,"景东","CN101290903"],[2,"澜沧","CN101290904"],[3,"思茅","CN101290905"],[4,"墨江","CN101290906"],[5,"江城","CN101290907"],[6,"孟连","CN101290908"],[7,"西盟","CN101290909"],[8,"镇沅","CN101290911"],[9,"宁洱","CN101290912"]
  ],
  "0_24_9":[
    [0,"鲁甸","CN101291002"],[1,"彝良","CN101291003"],[2,"镇雄","CN101291004"],[3,"威信","CN101291005"],[4,"巧家","CN101291006"],[5,"绥江","CN101291007"],[6,"永善","CN101291008"],[7,"盐津","CN101291009"],[8,"大关","CN101291010"],[9,"水富","CN101291011"],[10,"昭阳","CN101291012"]
  ],
  "0_24_10":[
    [0,"沧源","CN101291102"],[1,"耿马","CN101291103"],[2,"双江","CN101291104"],[3,"凤庆","CN101291105"],[4,"永德","CN101291106"],[5,"云县","CN101291107"],[6,"镇康","CN101291108"],[7,"临翔","CN101291109"]
  ],
  "0_24_11":[
    [0,"福贡","CN101291203"],[1,"兰坪","CN101291204"],[2,"泸水","CN101291205"],[3,"贡山","CN101291207"]
  ],
  "0_24_12":[
    [0,"香格里拉","CN101291301"],[1,"德钦","CN101291302"],[2,"维西","CN101291303"]
  ],
  "0_24_13":[
    [0,"永胜","CN101291402"],[1,"华坪","CN101291403"],[2,"宁蒗","CN101291404"],[3,"古城","CN101291405"],[4,"玉龙","CN101291406"]
  ],
  "0_24_14":[
    [0,"陇川","CN101291503"],[1,"盈江","CN101291504"],[2,"瑞丽","CN101291506"],[3,"梁河","CN101291507"],[4,"芒市","CN101291508"]
  ],
  "0_24_15":[
    [0,"景洪","CN101291601"],[1,"勐海","CN101291603"],[2,"勐腊","CN101291605"]
  ],
  "0_25":[
    [0,"拉萨市","CN101140101"],[1,"日喀则市","CN101140201"],[2,"山南市","CN101140301"],[3,"林芝市","CN101140401"],[4,"昌都市","CN101140501"],[5,"那曲市","CN101140601"],[6,"阿里","CN101140701"]
  ],
  "0_25_0":[
    [0,"当雄","CN101140102"],[1,"尼木","CN101140103"],[2,"林周","CN101140104"],[3,"堆龙德庆","CN101140105"],[4,"曲水","CN101140106"],[5,"达孜","CN101140107"],[6,"墨竹工卡","CN101140108"],[7,"城关","CN101140109"]
  ],
  "0_25_1":[
    [0,"拉孜","CN101140202"],[1,"南木林","CN101140203"],[2,"聂拉木","CN101140204"],[3,"定日","CN101140205"],[4,"江孜","CN101140206"],[6,"仲巴","CN101140208"],[7,"萨嘎","CN101140209"],[8,"吉隆","CN101140210"],[9,"昂仁","CN101140211"],[10,"定结","CN101140212"],[11,"萨迦","CN101140213"],[12,"谢通门","CN101140214"],[13,"桑珠孜","CN101140215"],[14,"岗巴","CN101140216"],[15,"白朗","CN101140217"],[16,"亚东","CN101140218"],[17,"康马","CN101140219"],[18,"仁布","CN101140220"]
  ],
  "0_25_2":[
    [0,"贡嘎","CN101140302"],[1,"扎囊","CN101140303"],[2,"加查","CN101140304"],[3,"浪卡子","CN101140305"],[4,"错那","CN101140306"],[5,"隆子","CN101140307"],[7,"乃东","CN101140309"],[8,"桑日","CN101140310"],[9,"洛扎","CN101140311"],[10,"措美","CN101140312"],[11,"琼结","CN101140313"],[12,"曲松","CN101140314"]
  ],
  "0_25_3":[
    [0,"波密","CN101140402"],[1,"米林","CN101140403"],[2,"察隅","CN101140404"],[3,"工布江达","CN101140405"],[4,"朗县","CN101140406"],[5,"墨脱","CN101140407"],[6,"巴宜","CN101140408"]
  ],
  "0_25_4":[
    [0,"丁青","CN101140502"],[1,"边坝","CN101140503"],[2,"洛隆","CN101140504"],[3,"左贡","CN101140505"],[4,"芒康","CN101140506"],[5,"类乌齐","CN101140507"],[6,"八宿","CN101140508"],[7,"江达","CN101140509"],[8,"察雅","CN101140510"],[9,"贡觉","CN101140511"],[10,"卡若","CN101140512"]
  ],
  "0_25_5":[
    [0,"尼玛","CN101140602"],[1,"嘉黎","CN101140603"],[2,"班戈","CN101140604"],[3,"安多","CN101140605"],[4,"索县","CN101140606"],[5,"聂荣","CN101140607"],[6,"巴青","CN101140608"],[7,"比如","CN101140609"],[8,"双湖","CN101140610"],[9,"申扎","CN101140611"],[10,"色尼","CN101140612"]
  ],
  "0_25_6":[
    [0,"改则","CN101140702"],[2,"普兰","CN101140705"],[3,"札达","CN101140706"],[4,"噶尔","CN101140707"],[5,"日土","CN101140708"],[6,"革吉","CN101140709"],[7,"措勤","CN101140710"]
  ],
  "0_26":[
    [0,"西安市","CN101110101"],[1,"咸阳市","CN101110200"],[2,"延安市","CN101110300"],[3,"榆林市","CN101110401"],[4,"渭南市","CN101110501"],[5,"商洛市","CN101110601"],[6,"安康市","CN101110701"],[7,"汉中市","CN101110801"],[8,"宝鸡市","CN101110901"],[9,"铜川市","CN101111001"]
  ],
  "0_26_0":[
    [0,"长安","CN101110102"],[1,"临潼","CN101110103"],[2,"蓝田","CN101110104"],[3,"周至","CN101110105"],[4,"鄠邑","CN101110106"],[5,"高陵","CN101110107"],[6,"新城","CN101110108"],[7,"碑林","CN101110109"],[8,"莲湖","CN101110110"],[9,"灞桥","CN101110111"],[10,"未央","CN101110112"],[11,"雁塔","CN101110113"],[12,"阎良","CN101110114"]
  ],
  "0_26_1":[
    [0,"三原","CN101110201"],[1,"礼泉","CN101110202"],[2,"永寿","CN101110203"],[3,"淳化","CN101110204"],[4,"泾阳","CN101110205"],[5,"武功","CN101110206"],[6,"乾县","CN101110207"],[7,"彬州","CN101110208"],[8,"长武","CN101110209"],[9,"旬邑","CN101110210"],[10,"兴平","CN101110211"],[11,"秦都","CN101110212"],[12,"渭城","CN101110213"],[13,"杨陵","CN101111102"]
  ],
  "0_26_2":[
    [0,"延长","CN101110301"],[1,"延川","CN101110302"],[2,"子长","CN101110303"],[3,"宜川","CN101110304"],[4,"富县","CN101110305"],[5,"志丹","CN101110306"],[6,"安塞","CN101110307"],[7,"甘泉","CN101110308"],[8,"洛川","CN101110309"],[9,"黄陵","CN101110310"],[10,"黄龙","CN101110311"],[11,"吴起","CN101110312"],[12,"宝塔","CN101110313"]
  ],
  "0_26_3":[
    [0,"府谷","CN101110402"],[1,"神木","CN101110403"],[2,"佳县","CN101110404"],[3,"定边","CN101110405"],[4,"靖边","CN101110406"],[5,"横山","CN101110407"],[6,"米脂","CN101110408"],[7,"子洲","CN101110409"],[8,"绥德","CN101110410"],[9,"吴堡","CN101110411"],[10,"清涧","CN101110412"],[11,"榆阳","CN101110413"]
  ],
  "0_26_4":[
    [0,"潼关","CN101110503"],[1,"大荔","CN101110504"],[2,"白水","CN101110505"],[3,"富平","CN101110506"],[4,"蒲城","CN101110507"],[5,"澄城","CN101110508"],[6,"合阳","CN101110509"],[7,"韩城","CN101110510"],[8,"华阴","CN101110511"],[9,"临渭","CN101110512"],[10,"华州","CN101110513"]
  ],
  "0_26_5":[
    [0,"洛南","CN101110602"],[1,"柞水","CN101110603"],[2,"商州","CN101110604"],[3,"镇安","CN101110605"],[4,"丹凤","CN101110606"],[5,"商南","CN101110607"],[6,"山阳","CN101110608"]
  ],
  "0_26_6":[
    [0,"紫阳","CN101110702"],[1,"石泉","CN101110703"],[2,"汉阴","CN101110704"],[3,"旬阳","CN101110705"],[4,"岚皋","CN101110706"],[5,"平利","CN101110707"],[6,"白河","CN101110708"],[7,"镇坪","CN101110709"],[8,"宁陕","CN101110710"],[9,"汉滨","CN101110711"]
  ],
  "0_26_7":[
    [0,"略阳","CN101110802"],[1,"勉县","CN101110803"],[2,"留坝","CN101110804"],[3,"洋县","CN101110805"],[4,"城固","CN101110806"],[5,"西乡","CN101110807"],[6,"佛坪","CN101110808"],[7,"宁强","CN101110809"],[8,"南郑","CN101110810"],[9,"镇巴","CN101110811"],[10,"汉台","CN101110812"]
  ],
  "0_26_8":[
    [0,"渭滨","CN101110902"],[1,"千阳","CN101110903"],[2,"麟游","CN101110904"],[3,"岐山","CN101110905"],[4,"凤翔","CN101110906"],[5,"扶风","CN101110907"],[6,"眉县","CN101110908"],[7,"太白","CN101110909"],[8,"凤县","CN101110910"],[9,"陇县","CN101110911"],[10,"陈仓","CN101110912"],[11,"金台","CN101110913"]
  ],
  "0_26_9":[
    [0,"宜君","CN101111003"],[1,"耀州","CN101111004"],[2,"王益","CN101111005"],[3,"印台","CN101111006"]
  ],
  "0_27":[
    [0,"兰州市","CN101160101"],[1,"定西市","CN101160201"],[2,"平凉市","CN101160301"],[3,"庆阳市","CN101160401"],[4,"武威市","CN101160501"],[5,"金昌市","CN101160601"],[6,"张掖市","CN101160701"],[7,"酒泉市","CN101160801"],[8,"天水市","CN101160901"],[9,"陇南市","CN101161010"],[10,"临夏州","CN101161101"],[11,"甘南州","CN101161209"],[12,"白银市","CN101161301"],[13,"嘉峪关市","CN101161401"]
  ],
  "0_27_0":[
    [0,"皋兰","CN101160102"],[1,"永登","CN101160103"],[2,"榆中","CN101160104"],[3,"城关","CN101160105"],[4,"七里河","CN101160106"],[5,"西固","CN101160107"],[6,"安宁","CN101160108"],[7,"红古","CN101160109"]
  ],
  "0_27_1":[
    [0,"通渭","CN101160202"],[1,"陇西","CN101160203"],[2,"渭源","CN101160204"],[3,"临洮","CN101160205"],[4,"漳县","CN101160206"],[5,"岷县","CN101160207"],[6,"安定","CN101160208"]
  ],
  "0_27_2":[
    [0,"泾川","CN101160302"],[1,"灵台","CN101160303"],[2,"崇信","CN101160304"],[3,"华亭","CN101160305"],[4,"庄浪","CN101160306"],[5,"静宁","CN101160307"],[6,"崆峒","CN101160308"]
  ],
  "0_27_3":[
    [0,"西峰","CN101160402"],[1,"环县","CN101160403"],[2,"华池","CN101160404"],[3,"合水","CN101160405"],[4,"正宁","CN101160406"],[5,"宁县","CN101160407"],[6,"镇原","CN101160408"],[7,"庆城","CN101160409"]
  ],
  "0_27_4":[
    [0,"民勤","CN101160502"],[1,"古浪","CN101160503"],[2,"凉州","CN101160504"],[3,"天祝","CN101160505"]
  ],
  "0_27_5":[
    [0,"永昌","CN101160602"],[1,"金川","CN101160603"]
  ],
  "0_27_6":[
    [0,"肃南","CN101160702"],[1,"民乐","CN101160703"],[2,"临泽","CN101160704"],[3,"高台","CN101160705"],[4,"山丹","CN101160706"],[5,"甘州","CN101160707"]
  ],
  "0_27_7":[
    [0,"肃州","CN101160802"],[1,"金塔","CN101160803"],[2,"阿克塞","CN101160804"],[3,"瓜州","CN101160805"],[4,"肃北","CN101160806"],[5,"玉门","CN101160807"],[6,"敦煌","CN101160808"]
  ],
  "0_27_8":[
    [0,"秦州","CN101160902"],[1,"清水","CN101160903"],[2,"秦安","CN101160904"],[3,"甘谷","CN101160905"],[4,"武山","CN101160906"],[5,"张家川","CN101160907"],[6,"麦积","CN101160908"]
  ],
  "0_27_9":[
    [0,"武都","CN101161001"],[1,"成县","CN101161002"],[2,"文县","CN101161003"],[3,"宕昌","CN101161004"],[4,"康县","CN101161005"],[5,"西和","CN101161006"],[6,"礼县","CN101161007"],[7,"徽县","CN101161008"],[8,"两当","CN101161009"]
  ],
  "0_27_10":[
    [0,"康乐","CN101161102"],[1,"永靖","CN101161103"],[2,"广河","CN101161104"],[3,"和政","CN101161105"],[4,"东乡","CN101161106"],[5,"积石山","CN101161107"],[6,"临夏市","CN101161108"],[7,"临夏县","CN101161109"]
  ],
  "0_27_11":[
    [0,"合作","CN101161201"],[1,"临潭","CN101161202"],[2,"卓尼","CN101161203"],[3,"舟曲","CN101161204"],[4,"迭部","CN101161205"],[5,"玛曲","CN101161206"],[6,"碌曲","CN101161207"],[7,"夏河","CN101161208"]
  ],
  "0_27_12":[
    [0,"靖远","CN101161302"],[1,"会宁","CN101161303"],[2,"平川","CN101161304"],[3,"景泰","CN101161305"],[4,"白银区","CN101161306"]
  ],
  "0_28":[
    [0,"西宁市","CN101150101"],[1,"海东市","CN101150207"],[2,"黄南州","CN101150305"],[3,"海南州","CN101150402"],[4,"果洛州","CN101150507"],[5,"玉树州","CN101150601"],[6,"海西州","CN101150702"],[7,"海北州","CN101150804"]
  ],
  "0_28_0":[
    [0,"大通","CN101150102"],[1,"湟源","CN101150103"],[2,"湟中","CN101150104"],[3,"城东","CN101150105"],[4,"城中","CN101150106"],[5,"城西","CN101150107"],[6,"城北","CN101150108"]
  ],
  "0_28_1":[
    [0,"平安","CN101150201"],[1,"乐都","CN101150202"],[2,"民和","CN101150203"],[3,"互助","CN101150204"],[4,"化隆","CN101150205"],[5,"循化","CN101150206"]
  ],
  "0_28_2":[
    [0,"同仁","CN101150301"],[1,"尖扎","CN101150302"],[2,"泽库","CN101150303"],[3,"河南","CN101150304"]
  ],
  "0_28_3":[
    [0,"共和","CN101150401"],[1,"贵德","CN101150404"],[2,"兴海","CN101150406"],[3,"贵南","CN101150407"],[4,"同德","CN101150408"]
  ],
  "0_28_4":[
    [0,"玛沁","CN101150501"],[1,"班玛","CN101150502"],[2,"甘德","CN101150503"],[3,"达日","CN101150504"],[4,"久治","CN101150505"],[5,"玛多","CN101150506"]
  ],
  "0_28_5":[
    [0,"称多","CN101150602"],[1,"治多","CN101150603"],[2,"杂多","CN101150604"],[3,"囊谦","CN101150605"],[4,"曲麻莱","CN101150606"],[5,"玉树","CN101150607"]
  ],
  "0_28_6":[
    [0,"德令哈","CN101150701"],[1,"天峻","CN101150708"],[2,"乌兰","CN101150709"],[3,"茫崖","CN101150712"],[4,"大柴旦","CN101150713"],[5,"格尔木","CN101150714"],[6,"都兰","CN101150715"]
  ],
  "0_28_7":[
    [0,"海晏","CN101150801"],[1,"门源","CN101150802"],[2,"祁连","CN101150803"],[3,"刚察","CN101150806"]
  ],
  "0_29":[
    [0,"银川市","CN101170101"],[1,"石嘴山市","CN101170201"],[2,"吴忠市","CN101170301"],[3,"固原市","CN101170401"],[4,"中卫市","CN101170501"]
  ],
  "0_29_0":[
    [0,"永宁","CN101170102"],[1,"灵武","CN101170103"],[2,"贺兰","CN101170104"],[3,"兴庆","CN101170105"],[4,"西夏","CN101170106"],[5,"金凤","CN101170107"]
  ],
  "0_29_1":[
    [0,"惠农","CN101170202"],[1,"平罗","CN101170203"],[3,"大武口","CN101170205"]
  ],
  "0_29_2":[
    [0,"同心","CN101170302"],[1,"盐池","CN101170303"],[2,"利通","CN101170304"],[3,"红寺堡","CN101170305"],[4,"青铜峡","CN101170306"]
  ],
  "0_29_3":[
    [0,"西吉","CN101170402"],[1,"隆德","CN101170403"],[2,"泾源","CN101170404"],[3,"原州","CN101170405"],[4,"彭阳","CN101170406"]
  ],
  "0_29_4":[
    [0,"中宁","CN101170502"],[1,"沙坡头","CN101170503"],[2,"海原","CN101170504"]
  ],
  "0_30":[
    [0,"乌鲁木齐市","CN101130101"],[1,"克拉玛依市","CN101130201"],[2,"石河子市","CN101130301"],[3,"昌吉州","CN101130401"],[4,"吐鲁番市","CN101130501"],[5,"巴音郭楞州","CN101130609"],[6,"阿拉尔市","CN101130701"],[7,"阿克苏","CN101130801"],[8,"喀什","CN101130901"],[9,"伊犁州","CN101131012"],[10,"塔城","CN101131101"],[11,"哈密市","CN101131201"],[23,"和田","CN101131308"],[24,"阿勒泰","CN101131410"],[14,"克孜勒州","CN101131505"],[15,"博尔塔拉州","CN101131604"],[16,"图木舒克市","CN101131701"],[17,"五家渠市","CN101131801"],[18,"铁门关市","CN101131901"],[19,"昆玉市","CN101131920"],[20,"北屯市","CN101132101"],[21,"双河市","CN101132201"],[22,"可克达拉市","CN101132301"],[25,"胡杨河市","CN101132401"]
  ],
  "0_30_0":[
    [0,"天山","CN101130102"],[2,"沙依巴克","CN101130104"],[3,"达坂城","CN101130105"],[4,"新市","CN101130106"],[5,"水磨沟","CN101130107"],[7,"头屯河","CN101130111"],[8,"米东","CN101130112"],[9,"乌鲁木齐县","CN101130113"]
  ],
  "0_30_1":[
    [0,"乌尔禾","CN101130202"],[1,"白碱滩","CN101130203"],[2,"独山子","CN101130204"],[3,"克拉玛依区","CN101130205"]
  ],
  "0_30_3":[
    [0,"呼图壁","CN101130402"],[1,"阜康","CN101130404"],[2,"吉木萨尔","CN101130405"],[3,"奇台","CN101130406"],[4,"玛纳斯","CN101130407"],[5,"木垒","CN101130408"],[6,"昌吉市","CN101130410"]
  ],
  "0_30_4":[
    [0,"托克逊","CN101130502"],[1,"高昌","CN101130503"],[2,"鄯善","CN101130504"]
  ],
  "0_30_5":[
    [0,"库尔勒","CN101130601"],[1,"轮台","CN101130602"],[2,"尉犁","CN101130603"],[3,"若羌","CN101130604"],[4,"且末","CN101130605"],[5,"和静","CN101130606"],[6,"焉耆","CN101130607"],[7,"和硕","CN101130608"],[10,"博湖","CN101130612"]
  ],
  "0_30_7":[
    [0,"乌什","CN101130802"],[1,"温宿","CN101130803"],[2,"拜城","CN101130804"],[3,"新和","CN101130805"],[4,"沙雅","CN101130806"],[5,"库车","CN101130807"],[6,"柯坪","CN101130808"],[7,"阿瓦提","CN101130809"],[8,"阿克苏市","CN101130810"]
  ],
  "0_30_8":[
    [0,"英吉沙","CN101130902"],[1,"塔什库尔干","CN101130903"],[2,"麦盖提","CN101130904"],[3,"莎车","CN101130905"],[4,"叶城","CN101130906"],[5,"泽普","CN101130907"],[6,"巴楚","CN101130908"],[7,"岳普湖","CN101130909"],[8,"伽师","CN101130910"],[9,"疏附","CN101130911"],[10,"疏勒","CN101130912"],[11,"喀什市","CN101130913"]
  ],
  "0_30_9":[
    [0,"伊宁","CN101131001"],[1,"察布查尔","CN101131002"],[2,"尼勒克","CN101131003"],[3,"伊宁县","CN101131004"],[4,"巩留","CN101131005"],[5,"新源","CN101131006"],[6,"昭苏","CN101131007"],[7,"特克斯","CN101131008"],[8,"霍城","CN101131009"],[9,"霍尔果斯","CN101131010"],[10,"奎屯","CN101131011"]
  ],
  "0_30_10":[
    [0,"裕民","CN101131102"],[1,"额敏","CN101131103"],[2,"和布克赛尔","CN101131104"],[3,"托里","CN101131105"],[4,"乌苏","CN101131106"],[5,"沙湾","CN101131107"],[6,"塔城市","CN101131108"]
  ],
  "0_30_11":[
    [0,"伊州","CN101131202"],[1,"巴里坤","CN101131203"],[2,"伊吾","CN101131204"]
  ],
  "0_30_23":[
    [0,"和田","CN101131301"],[1,"皮山","CN101131302"],[2,"策勒","CN101131303"],[3,"墨玉","CN101131304"],[4,"洛浦","CN101131305"],[5,"民丰","CN101131306"],[6,"于田","CN101131307"],[7,"和田县","CN101131309"]
  ],
  "0_30_24":[
    [0,"阿勒泰","CN101131401"],[1,"哈巴河","CN101131402"],[2,"吉木乃","CN101131405"],[3,"布尔津","CN101131406"],[4,"福海","CN101131407"],[5,"富蕴","CN101131408"],[6,"青河","CN101131409"]
  ],
  "0_30_14":[
    [0,"阿图什","CN101131501"],[1,"乌恰","CN101131502"],[2,"阿克陶","CN101131503"],[3,"阿合奇","CN101131504"]
  ],
  "0_30_15":[
    [0,"博乐","CN101131601"],[1,"温泉","CN101131602"],[2,"精河","CN101131603"],[3,"阿拉山口","CN101131606"]
  ],
  "0_31":[
    [0,"香港","CN101320101"]
  ],
  "0_31_0":[
    [0,"九龙","CN101320102"],[1,"新界","CN101320103"]
  ],
  "0_32":[
    [0,"澳门","CN101330101"]
  ],
  "0_32_0":[
    [0,"氹仔岛","CN101330102"],[1,"路环岛","CN101330103"]
  ],
  "0_33":[
    [0,"台北市","CN101340101"],[3,"桃园市","CN101340102"],[4,"新竹市","CN101340103"],[5,"宜兰市","CN101340104"],[1,"高雄市","CN101340201"],[6,"嘉义市","CN101340202"],[7,"台南市","CN101340203"],[8,"台东市","CN101340204"],[9,"屏东市","CN101340205"],[2,"台中市","CN101340401"],[10,"苗栗市","CN101340402"],[11,"彰化市","CN101340403"],[12,"南投市","CN101340404"],[13,"花莲市","CN101340405"],[14,"云林市","CN101340406"]
  ],
  "1":[
    [0, "印度尼西亚 - Indonesia"]
  ],
  "1_0":[
    [0,"棉兰 - Medan","ID1214520"],[1,"日惹 - Yogyakarta","ID1621177"],[2,"望加锡 - Makassar","ID1622786"],[3,"泗水 - Surabaya","ID1625822"],[4,"三口洋市 - Singkawang","ID1626916"],[5,"帕卢 - Palu","ID1633034"],[6,"巨港 - Palembang","ID1633070"],[7,"巴东 - Padang","ID1633419"],[8,"马塔普拉 - Martapura","ID1636022"],[9,"曼诺瓦里 - Manokwari","ID1636308"],[10,"万鸦老 - Manado","ID1636544"],[11,"哥伦打洛 - Gorontalo","ID1643837"],[12,"丹帕沙 - Denpasar","ID1645528"],[13,"万隆 - Bandung","ID1650357"],[14,"巴厘巴板 - Balikpapan","ID1650527"],[15,"安汶 - Ambon","ID1651531"],[16,"古邦 - Kupang","ID2057087"],[17,"阿马哈伊 - Amahai","ID1651591"],[18,"外南梦 - Banyuwangi","ID1650077"],[19,"毕栋 - Bitung","ID1648636"],[20,"芝拉扎 - Cilacap","ID2486001"],[21,"埃纳罗塔利 - Enarotali","ID2486002"],[22,"格斯尔 - Geser","ID2486003"],[23,"雅加达 - Jakarta","ID1642911"],[24,"卡利昂厄特 - Kalianget","ID1641977"],[25,"马杰内 - Majene","ID1636806"],[26,"纳比雷 - Nabire","ID1634614"],[27,"楠勒阿 - Namlea","ID2486004"],[28,"楠阿皮诺 - Nangapinoh","ID2486005"],[29,"巴罗 - Paloh","ID2486006"],[30,"槟港 - Pangkalpinang","ID1632654"],[31,"那雷尼 - Ranai","ID2486007"],[32,"萨拉纳 - Sanana","ID2486008"],[33,"三堡垄港市 - Semarang","ID1627896"],[34,"瑟朗 - Serang","ID1627549"],[35,"新当 - Sintang","ID2486009"],[36,"塔纳默拉 - Tanahmerah","ID2486010"],[37,"达仁巴 - Tarempa","ID2486011"],[38,"特加尔 - Tegal","ID1624494"],[39,"迪米卡 - Timika","ID2486012"],[40,"瓦梅纳 - Wamena","ID2486013"]
  ]
};

/*
* full-citys-api.js 省市区数据操作
* author:devin87@qq.com  
* update:2022/02/09 15:10
*/
(function (undefined) {
    let dataAll = { countries: [] },
        map_country_by_id = {},
        map_data_by_code = {},
        map_all_prov_by_name = {},
        map_all_city_by_name = {},
        map_all_area_by_name = {};

    /**
     * 数据类型
     * @enum {number}
     */
    let Types = {
        country: 1,
        prov: 2,
        city: 3,
        area: 4
    };

    let map_code_by_name = {
        '河北区': 'CN101031600',
        '河南县': 'CN101150304',
        '海南区': 'CN101080303',
        '海南州': 'CN101150402',
        '吉林市': 'CN101060201'
    };

    /**
     * @typedef IData
     * @property {number} id ID
     * @property {string} code 代码
     * @property {string} name 名称
     * @property {number} type 类型
     * @property {string} _name 格式化后的名称
     */
    /**
     * 将数组数据转为对象
     * @param {Array} data 原始数据
     * @param {number} type 类型，见 Types
     * @returns {IData}
     */
    function formatRawData(data, type) {
        return { type: type, id: data[0], name: data[1], code: data[2] };
    }

    /**
     * 获取子项列表
     * @returns {Array.<Array>}
     */
    function getRawSubs(key) {
        return dataAllCitys[key] || [];
    }

    /**
     * 格式化省份名称 eg:湖北省 => 湖北
     * @param {string} prov
     * @returns {string}
     */
    function formatProv(prov) {
        if (prov.length <= 2) return prov;
        return prov.replace(/[省市]$|国家及地区$/g, '');
    }

    /**
     * 格式化城市名称 eg:武汉市 => 武汉
     * @param {string} city
     * @returns {string}
     */
    function formatCity(city) {
        let name = city.length <= 2 ? city : city.replace(/国家及地区$|特别行政区$|[州市盟]$|地区$/g, '');
        return name.replace('襄樊', '襄阳').replace('思茅', '普洱');
    }

    /**
     * 格式化地区名称 eg:洪山区 => 洪山
     * @param {string} area 
     * @returns {string}
     */
    function formatArea(area) {
        if (area.length <= 2) return area;
        return area.replace(/[市县区]$/g, '');
    }

    /**
     * 初始化数据
     */
    function init() {
        dataAll = { countries: [] };

        (dataAllCitys.countries || [[0, '中国']]).forEach(function (data) {
            let data_country = formatRawData(data, Types.country),
                key_provs = data_country.id,
                list_prov = [],
                map_prov_by_id = {},
                map_prov_by_name = {},
                map_country_city_by_name = {};

            data_country.ctid = data_country.id;

            //provs
            getRawSubs(key_provs).forEach(function (data2) {
                let data_prov = formatRawData(data2, Types.prov),
                    key_citys = data_country.id + '_' + data_prov.id,
                    list_city = [],
                    map_city_by_id = {},
                    map_city_by_name = {};

                data_prov._name = formatProv(data_prov.name);
                data_prov.ctid = data_country.id;
                data_prov.pid = data_prov.id;

                //citys
                getRawSubs(key_citys).forEach(function (data3) {
                    let data_city = formatRawData(data3, Types.city),
                        key_areas = data_country.id + '_' + data_prov.id + '_' + data_city.id,
                        list_area = [],
                        map_area_by_id = {},
                        map_area_by_name = {};

                    data_city._name = formatCity(data_city.name);
                    data_city.ctid = data_prov.ctid;
                    data_city.pid = data_prov.id;
                    data_city.cid = data_city.id;

                    //areas
                    getRawSubs(key_areas).forEach(function (data4) {
                        let data_area = formatRawData(data4, Types.area);

                        data_area._name = formatArea(data_area.name);
                        data_area.ctid = data_city.ctid;
                        data_area.pid = data_city.pid;
                        data_area.cid = data_city.id;
                        data_area.aid = data_area.id;

                        list_area.push(data_area);
                        map_all_area_by_name[data_area._name] = map_area_by_name[data_area._name] = map_area_by_name[data_area.name] = map_area_by_id[data_area.id] = map_all_area_by_name[data_area.name] = map_data_by_code[data_area.code] = data_area;
                    });

                    list_city.push(data_city);
                    map_all_city_by_name[data_city._name] = map_city_by_id[data_city.id] = map_all_city_by_name[data_city.name] = map_data_by_code[data_city.code] = data_city;

                    let city_names = (data_city.name || '').split('-');
                    if (city_names.length > 0) {
                        city_names.forEach(function (name) {
                            name = name.trim();
                            if (!name) return;

                            let _name = formatCity(name);
                            map_country_city_by_name[_name] = map_city_by_name[_name] = map_country_city_by_name[name] = map_city_by_name[name] = data_city;
                        });
                    }

                    data_city.mapAreaId = map_area_by_id;
                    data_city.mapAreaName = map_area_by_name;

                    dataAll[key_areas] = list_area;
                });

                list_prov.push(data_prov);
                map_prov_by_id[data_prov.id] = data_prov;

                let prov_names = (data_prov.name || '').split('-');
                if (prov_names.length > 0) {
                    prov_names.forEach(function (name) {
                        name = name.trim();
                        if (!name) return;

                        let _name = formatCity(name);
                        map_prov_by_name[_name] = map_all_prov_by_name[_name] = map_prov_by_name[name] = map_all_prov_by_name[name] = data_prov;
                    });
                }

                data_prov.mapCityId = map_city_by_id;
                data_prov.mapCityName = map_city_by_name;

                dataAll[key_citys] = list_city;
            });

            data_country.mapProvId = map_prov_by_id;
            data_country.mapProvName = map_prov_by_name;
            data_country.mapAllCityName = map_country_city_by_name;

            map_country_by_id[data_country.id] = data_country;

            dataAll[key_provs] = list_prov;
            dataAll.countries.push(data_country);
        });
    }

    init();

    /**
     * @typedef IArea
     * @property {number} id 地区ID
     * @property {string} code 地区代码
     * @property {string} name 城市名称
     * @property {string} _name 格式化后的名称
     * @property {number} ctid 国家ID
     * @property {number} pid 省份ID
     * @property {number} cid 城市ID
     */
    /**
     * @typedef ICity
     * @property {number} id 城市ID
     * @property {string} code 城市代码
     * @property {string} name 城市名称
     * @property {string} _name 格式化后的名称
     * @property {number} ctid 国家ID
     * @property {number} pid 省份ID
     * @property {object.<number,IArea>} mapAreaId 区域ID索引
     * @property {object.<string,IArea>} mapAreaName 区域名称索引
     */
    /**
     * @typedef IProv
     * @property {number} id 省份ID
     * @property {string} name 省份名称
     * @property {string} _name 格式化后的名称
     * @property {number} ctid 国家ID
     * @property {object.<number,ICity>} mapCityId 城市ID索引
     * @property {object.<string,ICity>} mapCityName 城市名称索引
     */
    /**
     * @typedef ICountry
     * @property {number} id 国家ID
     * @property {string} name 国家名称
     * @property {number} type 类型，见 Types
     * @property {object.<number,IProv>} mapProvId 省份ID索引
     * @property {object.<string,IProv>} mapProvName 省份名称索引
     * @property {object.<string,IProv>} mapAllCityName 全国城市名称索引
     */
    /**
     * 获取国家列表 eg: [{id:0,name:'中国'}]
     * @returns {Array.<ICountry>}
     */
    function getCountries() {
        return dataAll.countries;
    }

    /**
     * 获取子项列表
     * @param {string} key eg: 0|0_0|0_0_0
     * @returns {Array.<IData>}
     */
    function getSubs(key) {
        return dataAll[key] || [];
    }
    /**
     * 根据国家id获取省份列表 eg: [{id:0,name:'北京',ctid:0}]
     * @param {string} ctid 国家id,默认为0
     * @returns {Array.<IProv>}
     */
    function getProvs(ctid) {
        return getSubs(ctid || '0');
    }
    /**
     * 根据国家id、省份id获取城市列表 eg: [{id:0,name:'海淀',ctid:0,pid:0}]
     * @param {string} pid 省份id,不能为空
     * @param {string} ctid 国家id,默认为0
     * @returns {Array.<ICity>}
     */
    function getCitys(pid, ctid) {
        return getSubs((ctid || '0') + '_' + pid);
    }

    /**
     * 根据国家id、省份id、城市id获取城区列表 eg: [{id:0,name:'蔡甸',ctid:0,pid:19,cid:0}]
     * @param {string} pid 省份id,不能为空
     * @param {string} cid 城市id,不能为空
     * @param {string} ctid 国家id,默认为0
     * @returns {Array.<IArea>}
     */
    function getAreas(pid, cid, ctid) {
        return getSubs((ctid || '0') + '_' + pid + '_' + cid);
    }

    /**
     * 获取国家对象 eg: {id:0,name:'中国'}
     * @param {string} ctid 国家id,默认为0
     * @returns {ICountry}
     */
    function getCountry(ctid) {
        return map_country_by_id[ctid || '0'];
    }

    /**
     * 获取省份对象 eg: {id:0,name:'北京',ctid:0}
     * @param {string} pid 省份id,不能为空
     * @param {string} ctid 国家id,默认为0
     * @returns {IProv}
     */
    function getProv(pid, ctid) {
        let data_country = getCountry(ctid);
        return data_country ? data_country.mapProvId[pid] : undefined;
    }

    /**
     * 获取城市省份对象 eg: {id:0,name:'北京',ctid:0}
     * @param {string} pid 省份id,不能为空
     * @param {string} cid 城市id,不能为空
     * @param {string} ctid 国家id,默认为0
     * @returns {ICity}
     */
    function getCity(pid, cid, ctid) {
        let data_prov = getProv(pid, ctid);
        return data_prov ? data_prov.mapCityId[cid] : undefined;
    }

    /**
     * 获取城区对象 eg: {id:0,name:'蔡甸',ctid:0,pid:19,cid:0}
     * @param {string} pid 省份id,不能为空
     * @param {string} cid 城市id,不能为空
     * @param {string} aid 城区id,不能为空
     * @param {string} ctid 国家id,默认为0
     * @returns {IArea}
     */
    function getArea(pid, cid, aid, ctid) {
        let data_city = getCity(pid, cid, ctid);
        return data_city ? data_city.mapAreaId[aid] : undefined;
    }

    /**
     * 获取对象 eg: {id:0,name:'蔡甸',ctid:0,pid:19,cid:0}
     * @param {string} pid 省份id,为空则获取国家对象
     * @param {string} cid 城市id,为空则获取省份对象
     * @param {string} aid 城区id,为空则获取城市对象
     * @param {string} ctid 国家id,默认为0
     */
    function getAuto(pid, cid, aid, ctid) {
        if (aid != undefined) return getArea(pid, cid, aid, ctid) || getCity(pid, cid, ctid);
        if (cid != undefined) return getCity(pid, cid, ctid);
        if (pid != undefined) return getProv(pid, cid, ctid);
        return getCountry(ctid);
    }

    /**
     * @typedef FormatData
     * @property {number} type 类型(1:国家|2:省份|3:城市|4:地区)
     * @property {string} code 代码
     * @property {number} ctid 国家ID
     * @property {string} country 国家名称
     * @property {number} pid 省份ID
     * @property {string} prov 省份名称
     * @property {number} cid 城市ID
     * @property {string} city 城市名称
     * @property {number} aid 地区ID
     * @property {string} area 地区名称
     */
    /**
     * 格式化输出 eg: {type,code,ctid,pid,cid,aid,country,prov,city,area}
     * @param {object} data 省份、城市或地区对象
     * @returns {FormatData}
     */
    function formatData(data) {
        if (!data) return;

        let result = {};

        if (data.type) result.type = data.type;
        if (data.code) result.code = data.code;

        if (data.ctid != undefined) result.ctid = data.ctid;
        if (data.pid != undefined) result.pid = data.pid;
        if (data.cid != undefined) result.cid = data.cid;
        if (data.aid != undefined) result.aid = data.aid;

        result.country = (getCountry(result.ctid) || {}).name;
        if (result.pid != undefined) result.prov = (getProv(result.pid, result.ctid) || {}).name;
        if (result.cid != undefined) result.city = (getCity(result.pid, result.cid, result.ctid) || {}).name;
        if (result.aid != undefined) result.area = (getArea(result.pid, result.cid, result.aid, result.ctid) || {}).name;

        return result;
    }

    /**
     * 根据代码获取城市或地区对象
     * @param {string} code 
     * @returns {IData}
     */
    function getDataByCode(code) {
        return map_data_by_code[map_code_by_name[code] || code];
    }

    /**
     * 根据城市、地区代码或名称获取对象
     * @param {string} name 城市、地区代码或名称 eg: CN101010100|武汉
     * @param {boolean} is_format 是否格式化结果, 默认为true {pid,cid,id,name} => {type,code,ctid,pid,cid,aid,country,prov,city,area}
     * @returns {FormatData}
     */
    function getCityOrArea(code, is_format) {
        if (!code) return;

        let data = getDataByCode(code) || map_all_city_by_name[code] || map_all_area_by_name[code];
        return data && is_format !== false ? formatData(data) : data;
    }

    /**
     * 根据城市、地区名称获取代码
     * @param {string} name 城市、地区名称 eg: 北京 => CN101010100
     * @returns {string}
     */
    function getCode(name) {
        let data = getCityOrArea(name, false);
        return data ? data.code : undefined;
    }

    /**
     * 在列表中查找指定名称对象
     * @param {Array.<IData>} list 对象列表 eg: [{id,code,name}]
     * @param {string} name 要查找的名称
     * @returns {IData}
     */
    function findInList(list, name) {
        for (let i = 0, len = list.length; i < len; i++) {
            let data = list[i];
            if (name.indexOf(data._name || data.name) != -1) return data;
        }
    }

    /**
     * 查找省份对象
     * @param {string} prov 省份名称 eg: 湖北|湖北武汉
     * @param {boolean} is_full_match 是否匹配完整名称，为false时将在所有省份列表中查找，默认为false
     * @param {string} ctid 国家id,默认为0
     * @returns {IProv}
     */
    function findProv(prov, is_full_match, ctid) {
        if (!prov) return;

        let _prov = formatProv(prov);

        let data_country = getCountry(ctid), data_prov;
        if (data_country) {
            data_prov = data_country.mapProvName[prov] || data_country.mapProvName[_prov];
            if (data_prov) return data_prov;
        }

        data_prov = map_all_prov_by_name[prov] || map_all_prov_by_name[_prov];
        if (data_prov || is_full_match) return data_prov;

        return findInList(getProvs(ctid), _prov);
    }

    /**
     * 查找城市对象
     * @param {string} city 城市名称或代码
     * @param {IProv|Array.<ICity>} data_prov 省份对象|城市列表,为空则查找所有城市
     * @param {boolean} is_full_match 是否匹配完整名称，为false时将在所有城市列表中查找，默认为false
     * @param {string} ctid 国家id,默认为0
     * @returns {ICity}
     */
    function findCity(city, data_prov, is_full_match, ctid) {
        if (!city) return;

        let data_city = getDataByCode(city);
        if (data_city) return data_city;

        let _city = formatCity(city);

        if (data_prov) {
            if (data_prov.mapCityName) {
                data_city = data_prov.mapCityName[city] || data_prov.mapCityName[_city];
                if (data_city) return data_city;
            }

            if (data_prov.id) return findInList(getCitys(data_prov.id, data_prov.ctid), _city);

            if (Array.isArray(data_prov)) return findInList(data_prov, _city);
        }

        let data_country = getCountry(ctid);
        if (data_country) {
            data_city = data_country.mapAllCityName[city] || data_country.mapAllCityName[_city];
            if (data_city) return data_city;
        }

        data_city = map_all_city_by_name[city] || map_all_city_by_name[_city];
        if (data_city || is_full_match) return data_city;

        let provs = getProvs(ctid);
        for (let i = 0, len = provs.length; i < len; i++) {
            let data_prov = provs[i];

            data_city = findInList(getCitys(data_prov.id, data_prov.ctid), _city);
            if (data_city) return data_city;
        }
    }

    /**
     * 查找地区对象
     * @param {ICity} data_city 
     * @param {string} area 
     * @returns {IArea}
     */
    function findArea(data_city, area) {
        if (!area) return;

        let _area = formatArea(area);

        if (!data_city) return map_all_area_by_name[area] || map_all_area_by_name[_area];
        return data_city.mapAreaName[area] || data_city.mapAreaName[_area] || findInList(getAreas(data_city.pid, data_city.id, data_city.ctid), _area);
    }

    /**
     * 查找省市数据 => {type,code,ctid,pid,cid,country,prov,city}
     * @param {string} prov 省份
     * @param {string} city 城市
     * @param {string} area 地区
     * @param {string} ctid 国家id,默认为0
     * @returns {FormatData}
     */
    function findData(prov, city, area, ctid) {
        let data_prov = prov ? findProv(prov, false, ctid) : undefined,
            data_city = city ? findCity(city, data_prov, false, ctid) : undefined,
            data_area = area ? findArea(data_city, area) : undefined;

        return formatData(data_area || data_city || data_prov);
    }

    /**
     * 查找省市区对象 => {type,code,ctid,pid,cid,aid,country,prov,city,area}
     * @param {string} addr 省市地址 eg:湖北武汉 联通|湖北省武汉市|湖北武汉|湖北|武汉|武汉武汉|武汉洪山
     * @param {boolean} is_full_match 是否匹配完整名称，为false时将在所有省份、城市列表中查找，默认为false
     * @param {string} ctid 国家id,默认为0
     * @returns {FormatData}
     */
    function find(addr, is_full_match, ctid) {
        let gs = (addr + '').split(' '),
            geo = gs[0] || '';

        if (!geo) return {};

        geo = geo + '';

        let result = getDataByCode(geo);
        if (result) return formatData(result);

        let i = geo.indexOf('省'), prov, city, area;
        if (i > 0) {
            prov = geo.slice(0, i);
            city = geo.slice(i + 1);
        } else {
            let data_prov = findProv(geo, true, ctid);
            if (data_prov) return formatData(data_prov);

            city = geo;
        }

        if (city) {
            let j = city.indexOf('市');
            if (j == -1) j = city.indexOf('州');
            if (j == -1) j = city.indexOf('盟');

            if (j != -1) {
                area = city.slice(j + 1);
                city = city.slice(0, j);
            } else {
                if (!prov) city = undefined;
            }
        }

        if (prov || city) return findData(prov, city, area, ctid);

        let data_prov = findProv(geo, is_full_match, ctid);
        if (data_prov) {
            i = geo.indexOf(data_prov._name);
            if (i != -1) city = geo.slice(i + data_prov._name.length);
        }

        city = city || geo;

        let data_city = findCity(city, data_prov, is_full_match, ctid), data_area;
        if (data_city) {
            i = city.indexOf(data_city._name);
            area = i != -1 ? city.slice(i + data_city._name.length) : undefined;

            if (area) data_area = findArea(data_city, area);
        } else {
            data_area = findArea(undefined, geo);
        }

        return formatData(data_area || data_city || data_prov);
    }

    let DC = {
        Types: Types,

        getSubs: getSubs,
        getCountries: getCountries,
        getProvs: getProvs,
        getCitys: getCitys,
        getAreas: getAreas,

        getCountry: getCountry,
        getProv: getProv,
        getCity: getCity,
        getArea: getArea,
        getAuto: getAuto,

        getCityOrArea: getCityOrArea,
        getCode: getCode,

        formatProv: formatProv,
        formatCity: formatCity,
        formatArea: formatArea,

        formatData: formatData,

        findProv: findProv,
        findCity: findCity,
        findData: findData,
        find: find
    };

    if (typeof module === 'object' && typeof module.exports === 'object') module.exports = DC;

    if (typeof window !== 'undefined') {
        window.DC2 = DC;
        if (!window.DC) window.DC = DC;
    }
})();